//region block: polyfills
if (typeof Math.imul === 'undefined') {
  Math.imul = function imul(a, b) {
    return (a & 4.29490176E9) * (b & 65535) + (a & 65535) * (b | 0) | 0;
  };
}
if (typeof ArrayBuffer.isView === 'undefined') {
  ArrayBuffer.isView = function (a) {
    return a != null && a.__proto__ != null && a.__proto__.__proto__ === Int8Array.prototype.__proto__;
  };
}
if (typeof Array.prototype.fill === 'undefined') {
  // Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill#Polyfill
  Object.defineProperty(Array.prototype, 'fill', {value: function (value) {
    // Steps 1-2.
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }
    var O = Object(this); // Steps 3-5.
    var len = O.length >>> 0; // Steps 6-7.
    var start = arguments[1];
    var relativeStart = start >> 0; // Step 8.
    var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len); // Steps 9-10.
    var end = arguments[2];
    var relativeEnd = end === undefined ? len : end >> 0; // Step 11.
    var finalValue = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len); // Step 12.
    while (k < finalValue) {
      O[k] = value;
      k++;
    }
    ; // Step 13.
    return O;
  }});
}
[Int8Array, Int16Array, Uint16Array, Int32Array, Float32Array, Float64Array].forEach(function (TypedArray) {
  if (typeof TypedArray.prototype.fill === 'undefined') {
    Object.defineProperty(TypedArray.prototype, 'fill', {value: Array.prototype.fill});
  }
});
if (typeof Math.clz32 === 'undefined') {
  Math.clz32 = function (log, LN2) {
    return function (x) {
      var asUint = x >>> 0;
      if (asUint === 0) {
        return 32;
      }
      return 31 - (log(asUint) / LN2 | 0) | 0; // the "| 0" acts like math.floor
    };
  }(Math.log, Math.LN2);
}
//endregion
//region block: imports
var imul_0 = Math.imul;
var isView = ArrayBuffer.isView;
var clz32 = Math.clz32;
//endregion
//region block: pre-declaration
initMetadataForInterface(CharSequence, 'CharSequence');
initMetadataForClass(Number_0, 'Number');
initMetadataForClass(Char, 'Char');
initMetadataForInterface(Collection, 'Collection');
initMetadataForInterface(KtList, 'List', VOID, VOID, [Collection]);
initMetadataForInterface(KtSet, 'Set', VOID, VOID, [Collection]);
initMetadataForInterface(Entry, 'Entry');
initMetadataForCompanion(Companion);
function asJsReadonlyMapView() {
  return createJsReadonlyMapViewFrom(this);
}
initMetadataForInterface(KtMap_0, 'Map');
initMetadataForCompanion(Companion_0);
function asJsMapView() {
  return createJsMapViewFrom(this);
}
initMetadataForInterface(KtMutableMap_0, 'MutableMap', VOID, VOID, [KtMap_0]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Enum, 'Enum');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Long, 'Long', VOID, Number_0);
initMetadataForClass(JsMapView, 'JsMapView', JsMapView, Map);
initMetadataForObject(Digit, 'Digit');
initMetadataForObject(Unit, 'Unit');
initMetadataForClass(AbstractCollection, 'AbstractCollection', VOID, VOID, [Collection]);
initMetadataForClass(AbstractMutableCollection, 'AbstractMutableCollection', VOID, AbstractCollection, [AbstractCollection, Collection]);
initMetadataForClass(IteratorImpl, 'IteratorImpl');
initMetadataForClass(AbstractMutableList, 'AbstractMutableList', VOID, AbstractMutableCollection, [AbstractMutableCollection, Collection, KtList]);
initMetadataForClass(AbstractMap, 'AbstractMap', VOID, VOID, [KtMap_0]);
initMetadataForClass(AbstractMutableMap, 'AbstractMutableMap', VOID, AbstractMap, [AbstractMap, KtMutableMap_0]);
initMetadataForClass(AbstractMutableSet, 'AbstractMutableSet', VOID, AbstractMutableCollection, [AbstractMutableCollection, Collection, KtSet]);
initMetadataForCompanion(Companion_3);
initMetadataForClass(ArrayList, 'ArrayList', ArrayList_init_$Create$, AbstractMutableList, [AbstractMutableList, Collection, KtList]);
initMetadataForClass(HashMap, 'HashMap', HashMap_init_$Create$, AbstractMutableMap, [AbstractMutableMap, KtMutableMap_0]);
initMetadataForClass(HashMapKeys, 'HashMapKeys', VOID, AbstractMutableSet, [Collection, KtSet, AbstractMutableSet]);
initMetadataForClass(HashMapValues, 'HashMapValues', VOID, AbstractMutableCollection, [Collection, AbstractMutableCollection]);
initMetadataForClass(HashMapEntrySetBase, 'HashMapEntrySetBase', VOID, AbstractMutableSet, [Collection, KtSet, AbstractMutableSet]);
initMetadataForClass(HashMapEntrySet, 'HashMapEntrySet', VOID, HashMapEntrySetBase);
initMetadataForClass(HashMapKeysDefault$iterator$1);
initMetadataForClass(HashMapKeysDefault, 'HashMapKeysDefault', VOID, AbstractMutableSet);
initMetadataForClass(HashMapValuesDefault$iterator$1);
initMetadataForClass(HashMapValuesDefault, 'HashMapValuesDefault', VOID, AbstractMutableCollection);
initMetadataForClass(HashSet, 'HashSet', HashSet_init_$Create$, AbstractMutableSet, [AbstractMutableSet, Collection, KtSet]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Itr, 'Itr');
initMetadataForClass(KeysItr, 'KeysItr', VOID, Itr);
initMetadataForClass(ValuesItr, 'ValuesItr', VOID, Itr);
initMetadataForClass(EntriesItr, 'EntriesItr', VOID, Itr);
initMetadataForClass(EntryRef, 'EntryRef', VOID, VOID, [Entry]);
function containsAllEntries(m) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(m, Collection)) {
      tmp = m.j();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = m.e();
    while (_iterator__ex2g4s.f()) {
      var element = _iterator__ex2g4s.g();
      // Inline function 'kotlin.collections.InternalMap.containsAllEntries.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry = element;
      var tmp_0;
      if (!(entry == null) ? isInterface(entry, Entry) : false) {
        tmp_0 = this.a6(entry);
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
initMetadataForInterface(InternalMap, 'InternalMap');
initMetadataForClass(InternalHashMap, 'InternalHashMap', InternalHashMap_init_$Create$, VOID, [InternalMap]);
initMetadataForObject(EmptyHolder, 'EmptyHolder');
initMetadataForClass(LinkedHashMap, 'LinkedHashMap', LinkedHashMap_init_$Create$, HashMap, [HashMap, KtMutableMap_0]);
initMetadataForClass(LinkedHashSet, 'LinkedHashSet', LinkedHashSet_init_$Create$, HashSet, [HashSet, Collection, KtSet]);
initMetadataForClass(Exception, 'Exception', Exception_init_$Create$, Error);
initMetadataForClass(RuntimeException, 'RuntimeException', RuntimeException_init_$Create$, Exception);
initMetadataForClass(IllegalArgumentException, 'IllegalArgumentException', IllegalArgumentException_init_$Create$, RuntimeException);
initMetadataForClass(IllegalStateException, 'IllegalStateException', IllegalStateException_init_$Create$, RuntimeException);
initMetadataForClass(UnsupportedOperationException, 'UnsupportedOperationException', UnsupportedOperationException_init_$Create$, RuntimeException);
initMetadataForClass(NoSuchElementException, 'NoSuchElementException', NoSuchElementException_init_$Create$, RuntimeException);
initMetadataForClass(Error_0, 'Error', Error_init_$Create$, Error);
initMetadataForClass(IndexOutOfBoundsException, 'IndexOutOfBoundsException', IndexOutOfBoundsException_init_$Create$, RuntimeException);
initMetadataForClass(AssertionError, 'AssertionError', AssertionError_init_$Create$, Error_0);
initMetadataForClass(ConcurrentModificationException, 'ConcurrentModificationException', ConcurrentModificationException_init_$Create$, RuntimeException);
initMetadataForClass(NullPointerException, 'NullPointerException', NullPointerException_init_$Create$, RuntimeException);
initMetadataForClass(NoWhenBranchMatchedException, 'NoWhenBranchMatchedException', NoWhenBranchMatchedException_init_$Create$, RuntimeException);
initMetadataForClass(ClassCastException, 'ClassCastException', ClassCastException_init_$Create$, RuntimeException);
initMetadataForClass(StringBuilder, 'StringBuilder', StringBuilder_init_$Create$_0, VOID, [CharSequence]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Regex, 'Regex');
initMetadataForClass(RegexOption, 'RegexOption', VOID, Enum);
initMetadataForClass(DurationUnit, 'DurationUnit', VOID, Enum);
initMetadataForClass(IteratorImpl_0, 'IteratorImpl');
initMetadataForCompanion(Companion_6);
initMetadataForClass(AbstractList, 'AbstractList', VOID, AbstractCollection, [AbstractCollection, KtList]);
initMetadataForClass(AbstractMap$keys$1$iterator$1);
initMetadataForClass(AbstractMap$values$1$iterator$1);
initMetadataForCompanion(Companion_7);
initMetadataForClass(AbstractSet, 'AbstractSet', VOID, AbstractCollection, [AbstractCollection, KtSet]);
initMetadataForClass(AbstractMap$keys$1, VOID, VOID, AbstractSet);
initMetadataForClass(AbstractMap$values$1, VOID, VOID, AbstractCollection);
initMetadataForCompanion(Companion_8);
initMetadataForObject(EmptyIterator, 'EmptyIterator');
initMetadataForObject(EmptySet, 'EmptySet', VOID, VOID, [KtSet]);
initMetadataForClass(EnumEntriesList, 'EnumEntriesList', VOID, AbstractList, [KtList, AbstractList]);
initMetadataForCompanion(Companion_9);
//endregion
function CharSequence() {
}
function Number_0() {
}
function indexOf(_this__u8e3s4, element) {
  if (element == null) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (_this__u8e3s4[index] == null) {
          return index;
        }
      }
       while (inductionVariable <= last);
  } else {
    var inductionVariable_0 = 0;
    var last_0 = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (equals(element, _this__u8e3s4[index_0])) {
          return index_0;
        }
      }
       while (inductionVariable_0 <= last_0);
  }
  return -1;
}
function toCollection(_this__u8e3s4, destination) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  while (inductionVariable < last) {
    var item = _this__u8e3s4[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    destination.c(item);
  }
  return destination;
}
function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  return joinTo(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
}
function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  buffer.d(prefix);
  var count = 0;
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  $l$loop: while (inductionVariable < last) {
    var element = _this__u8e3s4[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    count = count + 1 | 0;
    if (count > 1) {
      buffer.d(separator);
    }
    if (limit < 0 || count <= limit) {
      appendElement(buffer, element, transform);
    } else
      break $l$loop;
  }
  if (limit >= 0 && count > limit) {
    buffer.d(truncated);
  }
  buffer.d(postfix);
  return buffer;
}
function getOrNull(_this__u8e3s4, index) {
  return (0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false) ? _this__u8e3s4[index] : null;
}
function joinToString_0(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  return joinTo_0(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
}
function joinTo_0(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
  separator = separator === VOID ? ', ' : separator;
  prefix = prefix === VOID ? '' : prefix;
  postfix = postfix === VOID ? '' : postfix;
  limit = limit === VOID ? -1 : limit;
  truncated = truncated === VOID ? '...' : truncated;
  transform = transform === VOID ? null : transform;
  buffer.d(prefix);
  var count = 0;
  var _iterator__ex2g4s = _this__u8e3s4.e();
  $l$loop: while (_iterator__ex2g4s.f()) {
    var element = _iterator__ex2g4s.g();
    count = count + 1 | 0;
    if (count > 1) {
      buffer.d(separator);
    }
    if (limit < 0 || count <= limit) {
      appendElement(buffer, element, transform);
    } else
      break $l$loop;
  }
  if (limit >= 0 && count > limit) {
    buffer.d(truncated);
  }
  buffer.d(postfix);
  return buffer;
}
function toSet(_this__u8e3s4) {
  if (isInterface(_this__u8e3s4, Collection)) {
    var tmp;
    switch (_this__u8e3s4.h()) {
      case 0:
        tmp = emptySet();
        break;
      case 1:
        var tmp_0;
        if (isInterface(_this__u8e3s4, KtList)) {
          tmp_0 = _this__u8e3s4.i(0);
        } else {
          tmp_0 = _this__u8e3s4.e().g();
        }

        tmp = setOf(tmp_0);
        break;
      default:
        tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$_0(mapCapacity(_this__u8e3s4.h())));
        break;
    }
    return tmp;
  }
  return optimizeReadOnlySet(toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$()));
}
function toCollection_0(_this__u8e3s4, destination) {
  var _iterator__ex2g4s = _this__u8e3s4.e();
  while (_iterator__ex2g4s.f()) {
    var item = _iterator__ex2g4s.g();
    destination.c(item);
  }
  return destination;
}
function first(_this__u8e3s4) {
  if (_this__u8e3s4.j())
    throw NoSuchElementException_init_$Create$_0('List is empty.');
  return _this__u8e3s4.i(0);
}
function coerceAtLeast(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue.m(maximumValue) > 0)
    throw IllegalArgumentException_init_$Create$_0('Cannot coerce value to an empty range: maximum ' + maximumValue.toString() + ' is less than minimum ' + minimumValue.toString() + '.');
  if (_this__u8e3s4.m(minimumValue) < 0)
    return minimumValue;
  if (_this__u8e3s4.m(maximumValue) > 0)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceAtMost(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function _Char___init__impl__6a9atx(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _Char___init__impl__6a9atx_0(code) {
  // Inline function 'kotlin.UShort.toInt' call
  var tmp$ret$0 = _UShort___get_data__impl__g0245(code) & 65535;
  return _Char___init__impl__6a9atx(tmp$ret$0);
}
function Char__compareTo_impl_ypi4mb($this, other) {
  return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
}
function Char__minus_impl_a2frrh($this, other) {
  return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
}
function Char__toInt_impl_vasixd($this) {
  return _get_value__a43j40($this);
}
function toString($this) {
  // Inline function 'kotlin.js.unsafeCast' call
  return String.fromCharCode(_get_value__a43j40($this));
}
function Char() {
}
function KtList() {
}
function Collection() {
}
function KtSet() {
}
function Entry() {
}
protoOf(Companion).fromJsMap = function (map) {
  return createMapFrom(map);
};
function Companion() {
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function KtMap_0() {
}
protoOf(Companion_0).fromJsMap = function (map) {
  return createMutableMapFrom(map);
};
function Companion_0() {
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function KtMutableMap_0() {
}
function Companion_1() {
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function Enum(name, ordinal) {
  this.b1_1 = name;
  this.c1_1 = ordinal;
}
protoOf(Enum).d1 = function () {
  return this.b1_1;
};
protoOf(Enum).e1 = function () {
  return this.c1_1;
};
protoOf(Enum).f1 = function (other) {
  return compareTo(this.c1_1, other.c1_1);
};
protoOf(Enum).g1 = function (other) {
  return this.f1(other instanceof Enum ? other : THROW_CCE());
};
protoOf(Enum).equals = function (other) {
  return this === other;
};
protoOf(Enum).hashCode = function () {
  return identityHashCode(this);
};
protoOf(Enum).toString = function () {
  return this.b1_1;
};
function toString_0(_this__u8e3s4) {
  var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
  return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
}
function Companion_2() {
  Companion_instance_2 = this;
  this.h1_1 = new Long(0, -2147483648);
  this.i1_1 = new Long(-1, 2147483647);
  this.j1_1 = 8;
  this.k1_1 = 64;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 == null)
    new Companion_2();
  return Companion_instance_2;
}
function Long(low, high) {
  Companion_getInstance_2();
  Number_0.call(this);
  this.k_1 = low;
  this.l_1 = high;
}
protoOf(Long).m = function (other) {
  return compare(this, other);
};
protoOf(Long).g1 = function (other) {
  return this.m(other instanceof Long ? other : THROW_CCE());
};
protoOf(Long).l1 = function (other) {
  return add(this, other);
};
protoOf(Long).m1 = function (other) {
  return multiply(this, other);
};
protoOf(Long).n1 = function (other) {
  return divide(this, other);
};
protoOf(Long).o1 = function (other) {
  return modulo(this, other);
};
protoOf(Long).p1 = function () {
  return this.q1().l1(new Long(1, 0));
};
protoOf(Long).r1 = function (bitCount) {
  return shiftLeft(this, bitCount);
};
protoOf(Long).s1 = function (bitCount) {
  return shiftRight(this, bitCount);
};
protoOf(Long).q1 = function () {
  return new Long(~this.k_1, ~this.l_1);
};
protoOf(Long).t1 = function () {
  return this.k_1;
};
protoOf(Long).u1 = function () {
  return toNumber(this);
};
protoOf(Long).toString = function () {
  return toStringImpl(this, 10);
};
protoOf(Long).equals = function (other) {
  var tmp;
  if (other instanceof Long) {
    tmp = equalsLong(this, other);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(Long).hashCode = function () {
  return hashCode_0(this);
};
protoOf(Long).valueOf = function () {
  return this.u1();
};
function implement(interfaces) {
  var maxSize = 1;
  var masks = [];
  var inductionVariable = 0;
  var last = interfaces.length;
  while (inductionVariable < last) {
    var i = interfaces[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var currentSize = maxSize;
    var tmp0_elvis_lhs = i.prototype.$imask$;
    var imask = tmp0_elvis_lhs == null ? i.$imask$ : tmp0_elvis_lhs;
    if (!(imask == null)) {
      masks.push(imask);
      currentSize = imask.length;
    }
    var iid = i.$metadata$.iid;
    var tmp;
    if (iid == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.js.implement.<anonymous>' call
      tmp = bitMaskWith(iid);
    }
    var iidImask = tmp;
    if (!(iidImask == null)) {
      masks.push(iidImask);
      currentSize = Math.max(currentSize, iidImask.length);
    }
    if (currentSize > maxSize) {
      maxSize = currentSize;
    }
  }
  return compositeBitMask(maxSize, masks);
}
function bitMaskWith(activeBit) {
  var numberIndex = activeBit >> 5;
  var intArray = new Int32Array(numberIndex + 1 | 0);
  var positionInNumber = activeBit & 31;
  var numberWithSettledBit = 1 << positionInNumber;
  intArray[numberIndex] = intArray[numberIndex] | numberWithSettledBit;
  return intArray;
}
function compositeBitMask(capacity, masks) {
  var tmp = 0;
  var tmp_0 = new Int32Array(capacity);
  while (tmp < capacity) {
    var tmp_1 = tmp;
    var result = 0;
    var inductionVariable = 0;
    var last = masks.length;
    while (inductionVariable < last) {
      var mask = masks[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (tmp_1 < mask.length) {
        result = result | mask[tmp_1];
      }
    }
    tmp_0[tmp_1] = result;
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function isBitSet(_this__u8e3s4, possibleActiveBit) {
  var numberIndex = possibleActiveBit >> 5;
  if (numberIndex > _this__u8e3s4.length)
    return false;
  var positionInNumber = possibleActiveBit & 31;
  var numberWithSettledBit = 1 << positionInNumber;
  return !((_this__u8e3s4[numberIndex] & numberWithSettledBit) === 0);
}
function fillArrayVal(array, initValue) {
  var inductionVariable = 0;
  var last = array.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      array[i] = initValue;
    }
     while (!(i === last));
  return array;
}
function get_buf() {
  _init_properties_bitUtils_kt__nfcg4k();
  return buf;
}
var buf;
function get_bufFloat64() {
  _init_properties_bitUtils_kt__nfcg4k();
  return bufFloat64;
}
var bufFloat64;
var bufFloat32;
function get_bufInt32() {
  _init_properties_bitUtils_kt__nfcg4k();
  return bufInt32;
}
var bufInt32;
function get_lowIndex() {
  _init_properties_bitUtils_kt__nfcg4k();
  return lowIndex;
}
var lowIndex;
function get_highIndex() {
  _init_properties_bitUtils_kt__nfcg4k();
  return highIndex;
}
var highIndex;
function getNumberHashCode(obj) {
  _init_properties_bitUtils_kt__nfcg4k();
  // Inline function 'kotlin.js.jsBitwiseOr' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  if ((obj | 0) === obj) {
    return numberToInt(obj);
  }
  get_bufFloat64()[0] = obj;
  return imul_0(get_bufInt32()[get_highIndex()], 31) + get_bufInt32()[get_lowIndex()] | 0;
}
var properties_initialized_bitUtils_kt_i2bo3e;
function _init_properties_bitUtils_kt__nfcg4k() {
  if (!properties_initialized_bitUtils_kt_i2bo3e) {
    properties_initialized_bitUtils_kt_i2bo3e = true;
    buf = new ArrayBuffer(8);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    bufFloat64 = new Float64Array(get_buf());
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    bufFloat32 = new Float32Array(get_buf());
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    bufInt32 = new Int32Array(get_buf());
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.js.lowIndex.<anonymous>' call
    get_bufFloat64()[0] = -1.0;
    lowIndex = !(get_bufInt32()[0] === 0) ? 1 : 0;
    highIndex = 1 - get_lowIndex() | 0;
  }
}
function charSequenceGet(a, index) {
  var tmp;
  if (isString(a)) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.Char' call
    var code = a.charCodeAt(index);
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(0);
    if (code < Char__toInt_impl_vasixd(this_0)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(65535);
      tmp_0 = code > Char__toInt_impl_vasixd(this_1);
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$_0('Invalid Char code: ' + code);
    }
    tmp = numberToChar(code);
  } else {
    tmp = a.b(index);
  }
  return tmp;
}
function isString(a) {
  return typeof a === 'string';
}
function charSequenceLength(a) {
  var tmp;
  if (isString(a)) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = a.length;
  } else {
    tmp = a.a();
  }
  return tmp;
}
function arrayToString(array) {
  return joinToString(array, ', ', '[', ']', VOID, VOID, arrayToString$lambda);
}
function arrayToString$lambda(it) {
  return toString_1(it);
}
function UNSUPPORTED_OPERATION() {
  throw UnsupportedOperationException_init_$Create$();
}
function createJsReadonlyMapViewFrom(map) {
  var tmp = createJsReadonlyMapViewFrom$lambda(map);
  var tmp_0 = createJsReadonlyMapViewFrom$lambda_0(map);
  var tmp_1 = createJsReadonlyMapViewFrom$lambda_1(map);
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_2 = UNSUPPORTED_OPERATION$ref();
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_3 = UNSUPPORTED_OPERATION$ref_0();
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_4 = UNSUPPORTED_OPERATION$ref_1();
  var tmp_5 = createJsReadonlyMapViewFrom$lambda_2(map);
  var tmp_6 = createJsReadonlyMapViewFrom$lambda_3(map);
  var tmp_7 = createJsReadonlyMapViewFrom$lambda_4(map);
  return createJsMapViewWith(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, createJsReadonlyMapViewFrom$lambda_5);
}
function createJsMapViewFrom(map) {
  var tmp = createJsMapViewFrom$lambda(map);
  var tmp_0 = createJsMapViewFrom$lambda_0(map);
  var tmp_1 = createJsMapViewFrom$lambda_1(map);
  var tmp_2 = createJsMapViewFrom$lambda_2(map);
  var tmp_3 = createJsMapViewFrom$lambda_3(map);
  var tmp_4 = createJsMapViewFrom$lambda_4(map);
  var tmp_5 = createJsMapViewFrom$lambda_5(map);
  var tmp_6 = createJsMapViewFrom$lambda_6(map);
  var tmp_7 = createJsMapViewFrom$lambda_7(map);
  return createJsMapViewWith(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, createJsMapViewFrom$lambda_8);
}
function createJsIteratorFrom(iterator, transform) {
  var tmp;
  if (transform === VOID) {
    tmp = createJsIteratorFrom$lambda;
  } else {
    tmp = transform;
  }
  transform = tmp;
  var iteratorNext = createJsIteratorFrom$lambda_0(iterator);
  var iteratorHasNext = createJsIteratorFrom$lambda_1(iterator);
  var jsIterator = {next: function () {
    var result = {done: !iteratorHasNext()};
    if (!result.done)
      result.value = transform(iteratorNext());
    return result;
  }};
  jsIterator[Symbol.iterator] = function () {
    return this;
  };
  return jsIterator;
}
function forEach(cb, collection, thisArg) {
  thisArg = thisArg === VOID ? undefined : thisArg;
  var iterator = collection.entries();
  var result = iterator.next();
  while (!result.done) {
    var value = result.value;
    // Inline function 'kotlin.js.asDynamic' call
    cb.call(thisArg, value[1], value[0], collection);
    result = iterator.next();
  }
}
function createJsMapViewWith(mapSize, mapGet, mapContains, mapPut, mapRemove, mapClear, keysIterator, valuesIterator, entriesIterator, forEach) {
  // Inline function 'kotlin.also' call
  var this_0 = objectCreate(protoOf(JsMapView));
  // Inline function 'kotlin.collections.createJsMapViewWith.<anonymous>' call
  this_0[Symbol.iterator] = entriesIterator;
  defineProp(this_0, 'size', mapSize, VOID);
  var mapView = this_0;
  return Object.assign(mapView, {get: mapGet, set: function (key, value) {
    mapPut(key, value);
    return this;
  }, 'delete': mapRemove, clear: mapClear, has: mapContains, keys: keysIterator, values: valuesIterator, entries: entriesIterator, forEach: function (cb, thisArg) {
    forEach(cb, mapView, thisArg);
  }});
}
function JsMapView() {
  Map.call(this);
}
function createMapFrom(map) {
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.createMapFrom.<anonymous>' call
  forEach(createMapFrom$lambda(this_0), map);
  return this_0.b2();
}
function createMutableMapFrom(map) {
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.createMutableMapFrom.<anonymous>' call
  forEach(createMutableMapFrom$lambda(this_0), map);
  return this_0;
}
function createJsReadonlyMapViewFrom$lambda($map) {
  return function () {
    return $map.h();
  };
}
function createJsReadonlyMapViewFrom$lambda_0($map) {
  return function (k) {
    return $map.t(k);
  };
}
function createJsReadonlyMapViewFrom$lambda_1($map) {
  return function (k) {
    return $map.r(k);
  };
}
function UNSUPPORTED_OPERATION$ref() {
  var l = function () {
    UNSUPPORTED_OPERATION();
    return Unit_instance;
  };
  l.callableName = 'UNSUPPORTED_OPERATION';
  return l;
}
function UNSUPPORTED_OPERATION$ref_0() {
  var l = function () {
    UNSUPPORTED_OPERATION();
    return Unit_instance;
  };
  l.callableName = 'UNSUPPORTED_OPERATION';
  return l;
}
function UNSUPPORTED_OPERATION$ref_1() {
  var l = function () {
    UNSUPPORTED_OPERATION();
    return Unit_instance;
  };
  l.callableName = 'UNSUPPORTED_OPERATION';
  return l;
}
function createJsReadonlyMapViewFrom$lambda_2($map) {
  return function () {
    return createJsIteratorFrom($map.u().e());
  };
}
function createJsReadonlyMapViewFrom$lambda_3($map) {
  return function () {
    return createJsIteratorFrom($map.v().e());
  };
}
function createJsReadonlyMapViewFrom$lambda$lambda(it) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [it.p(), it.q()];
}
function createJsReadonlyMapViewFrom$lambda_4($map) {
  return function () {
    var tmp = $map.w().e();
    return createJsIteratorFrom(tmp, createJsReadonlyMapViewFrom$lambda$lambda);
  };
}
function createJsReadonlyMapViewFrom$lambda_5(callback, map, thisArg) {
  forEach(callback, map, thisArg);
  return Unit_instance;
}
function createJsMapViewFrom$lambda($map) {
  return function () {
    return $map.h();
  };
}
function createJsMapViewFrom$lambda_0($map) {
  return function (k) {
    return $map.t(k);
  };
}
function createJsMapViewFrom$lambda_1($map) {
  return function (k) {
    return $map.r(k);
  };
}
function createJsMapViewFrom$lambda_2($map) {
  return function (k, v) {
    $map.x(k, v);
    return Unit_instance;
  };
}
function createJsMapViewFrom$lambda_3($map) {
  return function (k) {
    $map.y(k);
    return Unit_instance;
  };
}
function createJsMapViewFrom$lambda_4($map) {
  return function () {
    $map.a1();
    return Unit_instance;
  };
}
function createJsMapViewFrom$lambda_5($map) {
  return function () {
    return createJsIteratorFrom($map.u().e());
  };
}
function createJsMapViewFrom$lambda_6($map) {
  return function () {
    return createJsIteratorFrom($map.v().e());
  };
}
function createJsMapViewFrom$lambda$lambda(it) {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [it.p(), it.q()];
}
function createJsMapViewFrom$lambda_7($map) {
  return function () {
    var tmp = $map.w().e();
    return createJsIteratorFrom(tmp, createJsMapViewFrom$lambda$lambda);
  };
}
function createJsMapViewFrom$lambda_8(callback, map, thisArg) {
  forEach(callback, map, thisArg);
  return Unit_instance;
}
function createJsIteratorFrom$lambda(it) {
  return it;
}
function createJsIteratorFrom$lambda_0($iterator) {
  return function () {
    return $iterator.g();
  };
}
function createJsIteratorFrom$lambda_1($iterator) {
  return function () {
    return $iterator.f();
  };
}
function createMapFrom$lambda($$this$buildMapInternal) {
  return function (value, key, _unused_var__etf5q3) {
    $$this$buildMapInternal.x(key, value);
    return Unit_instance;
  };
}
function createMutableMapFrom$lambda($$this$apply) {
  return function (value, key, _unused_var__etf5q3) {
    $$this$apply.x(key, value);
    return Unit_instance;
  };
}
function compareTo(a, b) {
  var tmp;
  switch (typeof a) {
    case 'number':
      var tmp_0;
      if (typeof b === 'number') {
        tmp_0 = doubleCompareTo(a, b);
      } else {
        if (b instanceof Long) {
          tmp_0 = doubleCompareTo(a, b.u1());
        } else {
          tmp_0 = primitiveCompareTo(a, b);
        }
      }

      tmp = tmp_0;
      break;
    case 'string':
    case 'boolean':
      tmp = primitiveCompareTo(a, b);
      break;
    default:
      tmp = compareToDoNotIntrinsicify(a, b);
      break;
  }
  return tmp;
}
function doubleCompareTo(a, b) {
  var tmp;
  if (a < b) {
    tmp = -1;
  } else if (a > b) {
    tmp = 1;
  } else if (a === b) {
    var tmp_0;
    if (a !== 0) {
      tmp_0 = 0;
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var ia = 1 / a;
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (ia === 1 / b) {
        tmp_1 = 0;
      } else {
        if (ia < 0) {
          tmp_1 = -1;
        } else {
          tmp_1 = 1;
        }
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  } else if (a !== a) {
    tmp = b !== b ? 0 : 1;
  } else {
    tmp = -1;
  }
  return tmp;
}
function primitiveCompareTo(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}
function compareToDoNotIntrinsicify(a, b) {
  return a.g1(b);
}
function identityHashCode(obj) {
  return getObjectHashCode(obj);
}
function getObjectHashCode(obj) {
  // Inline function 'kotlin.js.jsIn' call
  if (!('kotlinHashCodeValue$' in obj)) {
    var hash = calculateRandomHash();
    var descriptor = new Object();
    descriptor.value = hash;
    descriptor.enumerable = false;
    Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
  }
  // Inline function 'kotlin.js.unsafeCast' call
  return obj['kotlinHashCodeValue$'];
}
function calculateRandomHash() {
  // Inline function 'kotlin.js.jsBitwiseOr' call
  return Math.random() * 4.294967296E9 | 0;
}
function defineProp(obj, name, getter, setter) {
  return Object.defineProperty(obj, name, {configurable: true, get: getter, set: setter});
}
function objectCreate(proto) {
  proto = proto === VOID ? null : proto;
  return Object.create(proto);
}
function toString_1(o) {
  var tmp;
  if (o == null) {
    tmp = 'null';
  } else if (isArrayish(o)) {
    tmp = '[...]';
  } else if (!(typeof o.toString === 'function')) {
    tmp = anyToString(o);
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = o.toString();
  }
  return tmp;
}
function equals(obj1, obj2) {
  if (obj1 == null) {
    return obj2 == null;
  }
  if (obj2 == null) {
    return false;
  }
  if (typeof obj1 === 'object' && typeof obj1.equals === 'function') {
    return obj1.equals(obj2);
  }
  if (obj1 !== obj1) {
    return obj2 !== obj2;
  }
  if (typeof obj1 === 'number' && typeof obj2 === 'number') {
    var tmp;
    if (obj1 === obj2) {
      var tmp_0;
      if (obj1 !== 0) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = 1 / obj1;
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = tmp_1 === 1 / obj2;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  return obj1 === obj2;
}
function hashCode(obj) {
  if (obj == null)
    return 0;
  var typeOf = typeof obj;
  var tmp;
  switch (typeOf) {
    case 'object':
      tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
      break;
    case 'function':
      tmp = getObjectHashCode(obj);
      break;
    case 'number':
      tmp = getNumberHashCode(obj);
      break;
    case 'boolean':
      // Inline function 'kotlin.js.unsafeCast' call

      tmp = getBooleanHashCode(obj);
      break;
    case 'string':
      tmp = getStringHashCode(String(obj));
      break;
    case 'bigint':
      tmp = getBigIntHashCode(obj);
      break;
    case 'symbol':
      tmp = getSymbolHashCode(obj);
      break;
    default:
      tmp = function () {
        throw new Error('Unexpected typeof `' + typeOf + '`');
      }();
      break;
  }
  return tmp;
}
function anyToString(o) {
  return Object.prototype.toString.call(o);
}
function getBooleanHashCode(value) {
  return value ? 1231 : 1237;
}
function getStringHashCode(str) {
  var hash = 0;
  var length = str.length;
  var inductionVariable = 0;
  var last = length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var code = str.charCodeAt(i);
      hash = imul_0(hash, 31) + code | 0;
    }
     while (!(i === last));
  return hash;
}
function getBigIntHashCode(value) {
  var shiftNumber = BigInt(32);
  var MASK = BigInt(4.294967295E9);
  var bigNumber = value < 0 ? -value : value;
  var hashCode = 0;
  var signum = value < 0 ? -1 : 1;
  while (bigNumber != 0) {
    // Inline function 'kotlin.js.unsafeCast' call
    var chunk = Number(bigNumber & MASK);
    hashCode = imul_0(31, hashCode) + chunk | 0;
    bigNumber = bigNumber >> shiftNumber;
  }
  return imul_0(hashCode, signum);
}
function getSymbolHashCode(value) {
  var hashCodeMap = symbolIsSharable(value) ? getSymbolMap() : getSymbolWeakMap();
  var cachedHashCode = hashCodeMap.get(value);
  if (cachedHashCode !== VOID)
    return cachedHashCode;
  var hash = calculateRandomHash();
  hashCodeMap.set(value, hash);
  return hash;
}
function symbolIsSharable(symbol) {
  return Symbol.keyFor(symbol) != VOID;
}
function getSymbolMap() {
  if (symbolMap === VOID) {
    symbolMap = new Map();
  }
  return symbolMap;
}
function getSymbolWeakMap() {
  if (symbolWeakMap === VOID) {
    symbolWeakMap = new WeakMap();
  }
  return symbolWeakMap;
}
var symbolMap;
var symbolWeakMap;
function unboxIntrinsic(x) {
  var message = 'Should be lowered';
  throw IllegalStateException_init_$Create$_0(toString_1(message));
}
function captureStack(instance, constructorFunction) {
  if (Error.captureStackTrace != null) {
    Error.captureStackTrace(instance, constructorFunction);
  } else {
    // Inline function 'kotlin.js.asDynamic' call
    instance.stack = (new Error()).stack;
  }
}
function protoOf(constructor) {
  return constructor.prototype;
}
function extendThrowable(this_, message, cause) {
  Error.call(this_);
  setPropertiesToThrowableInstance(this_, message, cause);
}
function setPropertiesToThrowableInstance(this_, message, cause) {
  var errorInfo = calculateErrorInfo(Object.getPrototypeOf(this_));
  if ((errorInfo & 1) === 0) {
    var tmp;
    if (message == null) {
      var tmp_0;
      if (!(message === null)) {
        var tmp1_elvis_lhs = cause == null ? null : cause.toString();
        tmp_0 = tmp1_elvis_lhs == null ? VOID : tmp1_elvis_lhs;
      } else {
        tmp_0 = VOID;
      }
      tmp = tmp_0;
    } else {
      tmp = message;
    }
    this_.message = tmp;
  }
  if ((errorInfo & 2) === 0) {
    this_.cause = cause;
  }
  this_.name = Object.getPrototypeOf(this_).constructor.name;
}
function ensureNotNull(v) {
  var tmp;
  if (v == null) {
    THROW_NPE();
  } else {
    tmp = v;
  }
  return tmp;
}
function THROW_NPE() {
  throw NullPointerException_init_$Create$();
}
function noWhenBranchMatchedException() {
  throw NoWhenBranchMatchedException_init_$Create$();
}
function THROW_CCE() {
  throw ClassCastException_init_$Create$();
}
function THROW_IAE(msg) {
  throw IllegalArgumentException_init_$Create$_0(msg);
}
function get_ZERO() {
  _init_properties_longJs_kt__elc2w5();
  return ZERO;
}
var ZERO;
function get_ONE() {
  _init_properties_longJs_kt__elc2w5();
  return ONE;
}
var ONE;
function get_NEG_ONE() {
  _init_properties_longJs_kt__elc2w5();
  return NEG_ONE;
}
var NEG_ONE;
function get_MAX_VALUE() {
  _init_properties_longJs_kt__elc2w5();
  return MAX_VALUE;
}
var MAX_VALUE;
function get_MIN_VALUE() {
  _init_properties_longJs_kt__elc2w5();
  return MIN_VALUE;
}
var MIN_VALUE;
function get_TWO_PWR_24_() {
  _init_properties_longJs_kt__elc2w5();
  return TWO_PWR_24_;
}
var TWO_PWR_24_;
function compare(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  if (equalsLong(_this__u8e3s4, other)) {
    return 0;
  }
  var thisNeg = isNegative(_this__u8e3s4);
  var otherNeg = isNegative(other);
  return thisNeg && !otherNeg ? -1 : !thisNeg && otherNeg ? 1 : isNegative(subtract(_this__u8e3s4, other)) ? -1 : 1;
}
function add(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  var a48 = _this__u8e3s4.l_1 >>> 16 | 0;
  var a32 = _this__u8e3s4.l_1 & 65535;
  var a16 = _this__u8e3s4.k_1 >>> 16 | 0;
  var a00 = _this__u8e3s4.k_1 & 65535;
  var b48 = other.l_1 >>> 16 | 0;
  var b32 = other.l_1 & 65535;
  var b16 = other.k_1 >>> 16 | 0;
  var b00 = other.k_1 & 65535;
  var c48 = 0;
  var c32 = 0;
  var c16 = 0;
  var c00 = 0;
  c00 = c00 + (a00 + b00 | 0) | 0;
  c16 = c16 + (c00 >>> 16 | 0) | 0;
  c00 = c00 & 65535;
  c16 = c16 + (a16 + b16 | 0) | 0;
  c32 = c32 + (c16 >>> 16 | 0) | 0;
  c16 = c16 & 65535;
  c32 = c32 + (a32 + b32 | 0) | 0;
  c48 = c48 + (c32 >>> 16 | 0) | 0;
  c32 = c32 & 65535;
  c48 = c48 + (a48 + b48 | 0) | 0;
  c48 = c48 & 65535;
  return new Long(c16 << 16 | c00, c48 << 16 | c32);
}
function subtract(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  return add(_this__u8e3s4, other.p1());
}
function multiply(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  if (isZero(_this__u8e3s4)) {
    return get_ZERO();
  } else if (isZero(other)) {
    return get_ZERO();
  }
  if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
    return isOdd(other) ? get_MIN_VALUE() : get_ZERO();
  } else if (equalsLong(other, get_MIN_VALUE())) {
    return isOdd(_this__u8e3s4) ? get_MIN_VALUE() : get_ZERO();
  }
  if (isNegative(_this__u8e3s4)) {
    var tmp;
    if (isNegative(other)) {
      tmp = multiply(negate(_this__u8e3s4), negate(other));
    } else {
      tmp = negate(multiply(negate(_this__u8e3s4), other));
    }
    return tmp;
  } else if (isNegative(other)) {
    return negate(multiply(_this__u8e3s4, negate(other)));
  }
  if (lessThan(_this__u8e3s4, get_TWO_PWR_24_()) && lessThan(other, get_TWO_PWR_24_())) {
    return fromNumber(toNumber(_this__u8e3s4) * toNumber(other));
  }
  var a48 = _this__u8e3s4.l_1 >>> 16 | 0;
  var a32 = _this__u8e3s4.l_1 & 65535;
  var a16 = _this__u8e3s4.k_1 >>> 16 | 0;
  var a00 = _this__u8e3s4.k_1 & 65535;
  var b48 = other.l_1 >>> 16 | 0;
  var b32 = other.l_1 & 65535;
  var b16 = other.k_1 >>> 16 | 0;
  var b00 = other.k_1 & 65535;
  var c48 = 0;
  var c32 = 0;
  var c16 = 0;
  var c00 = 0;
  c00 = c00 + imul_0(a00, b00) | 0;
  c16 = c16 + (c00 >>> 16 | 0) | 0;
  c00 = c00 & 65535;
  c16 = c16 + imul_0(a16, b00) | 0;
  c32 = c32 + (c16 >>> 16 | 0) | 0;
  c16 = c16 & 65535;
  c16 = c16 + imul_0(a00, b16) | 0;
  c32 = c32 + (c16 >>> 16 | 0) | 0;
  c16 = c16 & 65535;
  c32 = c32 + imul_0(a32, b00) | 0;
  c48 = c48 + (c32 >>> 16 | 0) | 0;
  c32 = c32 & 65535;
  c32 = c32 + imul_0(a16, b16) | 0;
  c48 = c48 + (c32 >>> 16 | 0) | 0;
  c32 = c32 & 65535;
  c32 = c32 + imul_0(a00, b32) | 0;
  c48 = c48 + (c32 >>> 16 | 0) | 0;
  c32 = c32 & 65535;
  c48 = c48 + (((imul_0(a48, b00) + imul_0(a32, b16) | 0) + imul_0(a16, b32) | 0) + imul_0(a00, b48) | 0) | 0;
  c48 = c48 & 65535;
  return new Long(c16 << 16 | c00, c48 << 16 | c32);
}
function divide(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  if (isZero(other)) {
    throw Exception_init_$Create$_0('division by zero');
  } else if (isZero(_this__u8e3s4)) {
    return get_ZERO();
  }
  if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
    if (equalsLong(other, get_ONE()) || equalsLong(other, get_NEG_ONE())) {
      return get_MIN_VALUE();
    } else if (equalsLong(other, get_MIN_VALUE())) {
      return get_ONE();
    } else {
      var halfThis = shiftRight(_this__u8e3s4, 1);
      var approx = shiftLeft(halfThis.n1(other), 1);
      if (equalsLong(approx, get_ZERO())) {
        return isNegative(other) ? get_ONE() : get_NEG_ONE();
      } else {
        var rem = subtract(_this__u8e3s4, multiply(other, approx));
        return add(approx, rem.n1(other));
      }
    }
  } else if (equalsLong(other, get_MIN_VALUE())) {
    return get_ZERO();
  }
  if (isNegative(_this__u8e3s4)) {
    var tmp;
    if (isNegative(other)) {
      tmp = negate(_this__u8e3s4).n1(negate(other));
    } else {
      tmp = negate(negate(_this__u8e3s4).n1(other));
    }
    return tmp;
  } else if (isNegative(other)) {
    return negate(_this__u8e3s4.n1(negate(other)));
  }
  var res = get_ZERO();
  var rem_0 = _this__u8e3s4;
  while (greaterThanOrEqual(rem_0, other)) {
    var approxDouble = toNumber(rem_0) / toNumber(other);
    var approx2 = Math.max(1.0, Math.floor(approxDouble));
    var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
    var delta = log2 <= 48 ? 1.0 : Math.pow(2.0, log2 - 48);
    var approxRes = fromNumber(approx2);
    var approxRem = multiply(approxRes, other);
    while (isNegative(approxRem) || greaterThan(approxRem, rem_0)) {
      approx2 = approx2 - delta;
      approxRes = fromNumber(approx2);
      approxRem = multiply(approxRes, other);
    }
    if (isZero(approxRes)) {
      approxRes = get_ONE();
    }
    res = add(res, approxRes);
    rem_0 = subtract(rem_0, approxRem);
  }
  return res;
}
function modulo(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  return subtract(_this__u8e3s4, multiply(_this__u8e3s4.n1(other), other));
}
function shiftLeft(_this__u8e3s4, numBits) {
  _init_properties_longJs_kt__elc2w5();
  var numBits_0 = numBits & 63;
  if (numBits_0 === 0) {
    return _this__u8e3s4;
  } else {
    if (numBits_0 < 32) {
      return new Long(_this__u8e3s4.k_1 << numBits_0, _this__u8e3s4.l_1 << numBits_0 | (_this__u8e3s4.k_1 >>> (32 - numBits_0 | 0) | 0));
    } else {
      return new Long(0, _this__u8e3s4.k_1 << (numBits_0 - 32 | 0));
    }
  }
}
function shiftRight(_this__u8e3s4, numBits) {
  _init_properties_longJs_kt__elc2w5();
  var numBits_0 = numBits & 63;
  if (numBits_0 === 0) {
    return _this__u8e3s4;
  } else {
    if (numBits_0 < 32) {
      return new Long(_this__u8e3s4.k_1 >>> numBits_0 | 0 | _this__u8e3s4.l_1 << (32 - numBits_0 | 0), _this__u8e3s4.l_1 >> numBits_0);
    } else {
      return new Long(_this__u8e3s4.l_1 >> (numBits_0 - 32 | 0), _this__u8e3s4.l_1 >= 0 ? 0 : -1);
    }
  }
}
function toNumber(_this__u8e3s4) {
  _init_properties_longJs_kt__elc2w5();
  return _this__u8e3s4.l_1 * 4.294967296E9 + getLowBitsUnsigned(_this__u8e3s4);
}
function toStringImpl(_this__u8e3s4, radix) {
  _init_properties_longJs_kt__elc2w5();
  if (radix < 2 || 36 < radix) {
    throw Exception_init_$Create$_0('radix out of range: ' + radix);
  }
  if (isZero(_this__u8e3s4)) {
    return '0';
  }
  if (isNegative(_this__u8e3s4)) {
    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
      var radixLong = fromInt(radix);
      var div = _this__u8e3s4.n1(radixLong);
      var rem = subtract(multiply(div, radixLong), _this__u8e3s4).t1();
      var tmp = toStringImpl(div, radix);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      return tmp + rem.toString(radix);
    } else {
      return '-' + toStringImpl(negate(_this__u8e3s4), radix);
    }
  }
  var digitsPerTime = radix === 2 ? 31 : radix <= 10 ? 9 : radix <= 21 ? 7 : radix <= 35 ? 6 : 5;
  var radixToPower = fromNumber(Math.pow(radix, digitsPerTime));
  var rem_0 = _this__u8e3s4;
  var result = '';
  while (true) {
    var remDiv = rem_0.n1(radixToPower);
    var intval = subtract(rem_0, multiply(remDiv, radixToPower)).t1();
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var digits = intval.toString(radix);
    rem_0 = remDiv;
    if (isZero(rem_0)) {
      return digits + result;
    } else {
      while (digits.length < digitsPerTime) {
        digits = '0' + digits;
      }
      result = digits + result;
    }
  }
}
function equalsLong(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  return _this__u8e3s4.l_1 === other.l_1 && _this__u8e3s4.k_1 === other.k_1;
}
function hashCode_0(l) {
  _init_properties_longJs_kt__elc2w5();
  return l.k_1 ^ l.l_1;
}
function fromInt(value) {
  _init_properties_longJs_kt__elc2w5();
  return new Long(value, value < 0 ? -1 : 0);
}
function isNegative(_this__u8e3s4) {
  _init_properties_longJs_kt__elc2w5();
  return _this__u8e3s4.l_1 < 0;
}
function isZero(_this__u8e3s4) {
  _init_properties_longJs_kt__elc2w5();
  return _this__u8e3s4.l_1 === 0 && _this__u8e3s4.k_1 === 0;
}
function isOdd(_this__u8e3s4) {
  _init_properties_longJs_kt__elc2w5();
  return (_this__u8e3s4.k_1 & 1) === 1;
}
function negate(_this__u8e3s4) {
  _init_properties_longJs_kt__elc2w5();
  return _this__u8e3s4.p1();
}
function lessThan(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  return compare(_this__u8e3s4, other) < 0;
}
function fromNumber(value) {
  _init_properties_longJs_kt__elc2w5();
  if (isNaN_0(value)) {
    return get_ZERO();
  } else if (value <= -9.223372036854776E18) {
    return get_MIN_VALUE();
  } else if (value + 1 >= 9.223372036854776E18) {
    return get_MAX_VALUE();
  } else if (value < 0) {
    return negate(fromNumber(-value));
  } else {
    var twoPwr32 = 4.294967296E9;
    // Inline function 'kotlin.js.jsBitwiseOr' call
    var tmp = value % twoPwr32 | 0;
    // Inline function 'kotlin.js.jsBitwiseOr' call
    var tmp$ret$1 = value / twoPwr32 | 0;
    return new Long(tmp, tmp$ret$1);
  }
}
function greaterThan(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  return compare(_this__u8e3s4, other) > 0;
}
function greaterThanOrEqual(_this__u8e3s4, other) {
  _init_properties_longJs_kt__elc2w5();
  return compare(_this__u8e3s4, other) >= 0;
}
function getLowBitsUnsigned(_this__u8e3s4) {
  _init_properties_longJs_kt__elc2w5();
  return _this__u8e3s4.k_1 >= 0 ? _this__u8e3s4.k_1 : 4.294967296E9 + _this__u8e3s4.k_1;
}
var properties_initialized_longJs_kt_4syf89;
function _init_properties_longJs_kt__elc2w5() {
  if (!properties_initialized_longJs_kt_4syf89) {
    properties_initialized_longJs_kt_4syf89 = true;
    ZERO = fromInt(0);
    ONE = fromInt(1);
    NEG_ONE = fromInt(-1);
    MAX_VALUE = new Long(-1, 2147483647);
    MIN_VALUE = new Long(0, -2147483648);
    TWO_PWR_24_ = fromInt(16777216);
  }
}
function createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
  var undef = VOID;
  var iid = kind === 'interface' ? generateInterfaceId() : VOID;
  return {kind: kind, simpleName: name, associatedObjectKey: associatedObjectKey, associatedObjects: associatedObjects, suspendArity: suspendArity, $kClass$: undef, defaultConstructor: defaultConstructor, iid: iid};
}
function generateInterfaceId() {
  if (globalInterfaceId === VOID) {
    globalInterfaceId = 0;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  globalInterfaceId = globalInterfaceId + 1 | 0;
  // Inline function 'kotlin.js.unsafeCast' call
  return globalInterfaceId;
}
var globalInterfaceId;
function initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
  if (!(parent == null)) {
    ctor.prototype = Object.create(parent.prototype);
    ctor.prototype.constructor = ctor;
  }
  var metadata = createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity);
  ctor.$metadata$ = metadata;
  if (!(interfaces == null)) {
    var receiver = !equals(metadata.iid, VOID) ? ctor : ctor.prototype;
    receiver.$imask$ = implement(interfaces);
  }
}
function initMetadataForClass(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
  var kind = 'class';
  initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
}
function initMetadataForObject(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
  var kind = 'object';
  initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
}
function initMetadataForInterface(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
  var kind = 'interface';
  initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
}
function initMetadataForLambda(ctor, parent, interfaces, suspendArity) {
  initMetadataForClass(ctor, 'Lambda', VOID, parent, interfaces, suspendArity, VOID, VOID);
}
function initMetadataForCoroutine(ctor, parent, interfaces, suspendArity) {
  initMetadataForClass(ctor, 'Coroutine', VOID, parent, interfaces, suspendArity, VOID, VOID);
}
function initMetadataForFunctionReference(ctor, parent, interfaces, suspendArity) {
  initMetadataForClass(ctor, 'FunctionReference', VOID, parent, interfaces, suspendArity, VOID, VOID);
}
function initMetadataForCompanion(ctor, parent, interfaces, suspendArity) {
  initMetadataForObject(ctor, 'Companion', VOID, parent, interfaces, suspendArity, VOID, VOID);
}
function numberToInt(a) {
  var tmp;
  if (a instanceof Long) {
    tmp = a.t1();
  } else {
    tmp = doubleToInt(a);
  }
  return tmp;
}
function doubleToInt(a) {
  var tmp;
  if (a > 2147483647) {
    tmp = 2147483647;
  } else if (a < -2147483648) {
    tmp = -2147483648;
  } else {
    // Inline function 'kotlin.js.jsBitwiseOr' call
    tmp = a | 0;
  }
  return tmp;
}
function toShort(a) {
  // Inline function 'kotlin.js.unsafeCast' call
  return a << 16 >> 16;
}
function numberToLong(a) {
  var tmp;
  if (a instanceof Long) {
    tmp = a;
  } else {
    tmp = fromNumber(a);
  }
  return tmp;
}
function numberToChar(a) {
  // Inline function 'kotlin.toUShort' call
  var this_0 = numberToInt(a);
  var tmp$ret$0 = _UShort___init__impl__jigrne(toShort(this_0));
  return _Char___init__impl__6a9atx_0(tmp$ret$0);
}
function toLong(a) {
  return fromInt(a);
}
function isArrayish(o) {
  return isJsArray(o) || isView(o);
}
function isJsArray(obj) {
  // Inline function 'kotlin.js.unsafeCast' call
  return Array.isArray(obj);
}
function isInterface(obj, iface) {
  return isInterfaceImpl(obj, iface.$metadata$.iid);
}
function isInterfaceImpl(obj, iface) {
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp0_elvis_lhs = obj.$imask$;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var mask = tmp;
  return isBitSet(mask, iface);
}
function isCharSequence(value) {
  return typeof value === 'string' || isInterface(value, CharSequence);
}
function calculateErrorInfo(proto) {
  var tmp0_safe_receiver = proto.constructor;
  var metadata = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.$metadata$;
  var tmp2_safe_receiver = metadata == null ? null : metadata.errorInfo;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp2_safe_receiver;
  }
  var result = 0;
  if (hasProp(proto, 'message'))
    result = result | 1;
  if (hasProp(proto, 'cause'))
    result = result | 2;
  if (!(result === 3)) {
    var parentProto = getPrototypeOf(proto);
    if (parentProto != Error.prototype) {
      result = result | calculateErrorInfo(parentProto);
    }
  }
  if (!(metadata == null)) {
    metadata.errorInfo = result;
  }
  return result;
}
function hasProp(proto, propName) {
  return proto.hasOwnProperty(propName);
}
function getPrototypeOf(obj) {
  return Object.getPrototypeOf(obj);
}
function get_VOID() {
  _init_properties_void_kt__3zg9as();
  return VOID;
}
var VOID;
var properties_initialized_void_kt_e4ret2;
function _init_properties_void_kt__3zg9as() {
  if (!properties_initialized_void_kt_e4ret2) {
    properties_initialized_void_kt_e4ret2 = true;
    VOID = void 0;
  }
}
function copyOf(_this__u8e3s4, newSize) {
  // Inline function 'kotlin.require' call
  if (!(newSize >= 0)) {
    // Inline function 'kotlin.collections.copyOf.<anonymous>' call
    var message = 'Invalid new array size: ' + newSize + '.';
    throw IllegalArgumentException_init_$Create$_0(toString_1(message));
  }
  return fillFrom(_this__u8e3s4, new Int32Array(newSize));
}
function copyOf_0(_this__u8e3s4, newSize) {
  // Inline function 'kotlin.require' call
  if (!(newSize >= 0)) {
    // Inline function 'kotlin.collections.copyOf.<anonymous>' call
    var message = 'Invalid new array size: ' + newSize + '.';
    throw IllegalArgumentException_init_$Create$_0(toString_1(message));
  }
  return arrayCopyResize(_this__u8e3s4, newSize, null);
}
function digitToIntImpl(_this__u8e3s4) {
  // Inline function 'kotlin.code' call
  var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
  var index = binarySearchRange(Digit_getInstance().i2_1, ch);
  var diff = ch - Digit_getInstance().i2_1[index] | 0;
  return diff < 10 ? diff : -1;
}
function binarySearchRange(array, needle) {
  var bottom = 0;
  var top = array.length - 1 | 0;
  var middle = -1;
  var value = 0;
  while (bottom <= top) {
    middle = (bottom + top | 0) / 2 | 0;
    value = array[middle];
    if (needle > value)
      bottom = middle + 1 | 0;
    else if (needle === value)
      return middle;
    else
      top = middle - 1 | 0;
  }
  return middle - (needle < value ? 1 : 0) | 0;
}
function Digit() {
  Digit_instance = this;
  var tmp = this;
  // Inline function 'kotlin.intArrayOf' call
  tmp.i2_1 = new Int32Array([48, 1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3558, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43504, 43600, 44016, 65296]);
}
var Digit_instance;
function Digit_getInstance() {
  if (Digit_instance == null)
    new Digit();
  return Digit_instance;
}
function isNaN_0(_this__u8e3s4) {
  return !(_this__u8e3s4 === _this__u8e3s4);
}
function takeHighestOneBit(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === 0) {
    tmp = 0;
  } else {
    // Inline function 'kotlin.countLeadingZeroBits' call
    tmp = 1 << (31 - clz32(_this__u8e3s4) | 0);
  }
  return tmp;
}
function Unit() {
}
protoOf(Unit).toString = function () {
  return 'kotlin.Unit';
};
var Unit_instance;
function Unit_getInstance() {
  return Unit_instance;
}
function collectionToArray(collection) {
  return collectionToArrayCommonImpl(collection);
}
function mapCapacity(expectedSize) {
  return expectedSize;
}
function setOf(element) {
  return hashSetOf([element]);
}
function AbstractMutableCollection() {
  AbstractCollection.call(this);
}
protoOf(AbstractMutableCollection).j2 = function (element) {
  this.k2();
  var iterator = this.e();
  while (iterator.f()) {
    if (equals(iterator.g(), element)) {
      iterator.l2();
      return true;
    }
  }
  return false;
};
protoOf(AbstractMutableCollection).a1 = function () {
  this.k2();
  var iterator = this.e();
  while (iterator.f()) {
    iterator.g();
    iterator.l2();
  }
};
protoOf(AbstractMutableCollection).toJSON = function () {
  return this.toArray();
};
protoOf(AbstractMutableCollection).k2 = function () {
};
function IteratorImpl($outer) {
  this.o2_1 = $outer;
  this.m2_1 = 0;
  this.n2_1 = -1;
}
protoOf(IteratorImpl).f = function () {
  return this.m2_1 < this.o2_1.h();
};
protoOf(IteratorImpl).g = function () {
  if (!this.f())
    throw NoSuchElementException_init_$Create$();
  var tmp = this;
  var _unary__edvuaz = this.m2_1;
  this.m2_1 = _unary__edvuaz + 1 | 0;
  tmp.n2_1 = _unary__edvuaz;
  return this.o2_1.i(this.n2_1);
};
protoOf(IteratorImpl).l2 = function () {
  // Inline function 'kotlin.check' call
  if (!!(this.n2_1 === -1)) {
    // Inline function 'kotlin.collections.IteratorImpl.remove.<anonymous>' call
    var message = 'Call next() or previous() before removing element from the iterator.';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  this.o2_1.q2(this.n2_1);
  this.m2_1 = this.n2_1;
  this.n2_1 = -1;
};
function AbstractMutableList() {
  AbstractMutableCollection.call(this);
  this.p2_1 = 0;
}
protoOf(AbstractMutableList).c = function (element) {
  this.k2();
  this.r2(this.h(), element);
  return true;
};
protoOf(AbstractMutableList).e = function () {
  return new IteratorImpl(this);
};
protoOf(AbstractMutableList).n = function (element) {
  return this.s2(element) >= 0;
};
protoOf(AbstractMutableList).s2 = function (element) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = this.e();
    while (_iterator__ex2g4s.f()) {
      var item = _iterator__ex2g4s.g();
      // Inline function 'kotlin.collections.AbstractMutableList.indexOf.<anonymous>' call
      if (equals(item, element)) {
        tmp$ret$1 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$1 = -1;
  }
  return tmp$ret$1;
};
protoOf(AbstractMutableList).equals = function (other) {
  if (other === this)
    return true;
  if (!(!(other == null) ? isInterface(other, KtList) : false))
    return false;
  return Companion_instance_6.u2(this, other);
};
protoOf(AbstractMutableList).hashCode = function () {
  return Companion_instance_6.v2(this);
};
function AbstractMutableMap() {
  AbstractMap.call(this);
  this.y2_1 = null;
  this.z2_1 = null;
}
protoOf(AbstractMutableMap).a3 = function () {
  return new HashMapKeysDefault(this);
};
protoOf(AbstractMutableMap).b3 = function () {
  return new HashMapValuesDefault(this);
};
protoOf(AbstractMutableMap).u = function () {
  var tmp0_elvis_lhs = this.y2_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = this.a3();
    // Inline function 'kotlin.collections.AbstractMutableMap.<get-keys>.<anonymous>' call
    this.y2_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(AbstractMutableMap).v = function () {
  var tmp0_elvis_lhs = this.z2_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = this.b3();
    // Inline function 'kotlin.collections.AbstractMutableMap.<get-values>.<anonymous>' call
    this.z2_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(AbstractMutableMap).a1 = function () {
  this.w().a1();
};
protoOf(AbstractMutableMap).z = function (from) {
  this.k2();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = from.w().e();
  while (_iterator__ex2g4s.f()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.g();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.p();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.q();
    this.x(key, value);
  }
};
protoOf(AbstractMutableMap).y = function (key) {
  this.k2();
  var iter = this.w().e();
  while (iter.f()) {
    var entry = iter.g();
    var k = entry.p();
    if (equals(key, k)) {
      var value = entry.q();
      iter.l2();
      return value;
    }
  }
  return null;
};
protoOf(AbstractMutableMap).k2 = function () {
};
function AbstractMutableSet() {
  AbstractMutableCollection.call(this);
}
protoOf(AbstractMutableSet).equals = function (other) {
  if (other === this)
    return true;
  if (!(!(other == null) ? isInterface(other, KtSet) : false))
    return false;
  return Companion_instance_8.f3(this, other);
};
protoOf(AbstractMutableSet).hashCode = function () {
  return Companion_instance_8.g3(this);
};
function arrayOfUninitializedElements(capacity) {
  // Inline function 'kotlin.require' call
  if (!(capacity >= 0)) {
    // Inline function 'kotlin.collections.arrayOfUninitializedElements.<anonymous>' call
    var message = 'capacity must be non-negative.';
    throw IllegalArgumentException_init_$Create$_0(toString_1(message));
  }
  // Inline function 'kotlin.arrayOfNulls' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return fillArrayVal(Array(capacity), null);
}
function resetRange(_this__u8e3s4, fromIndex, toIndex) {
  // Inline function 'kotlin.js.nativeFill' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.fill(null, fromIndex, toIndex);
}
function copyOfUninitializedElements(_this__u8e3s4, newSize) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return copyOf_0(_this__u8e3s4, newSize);
}
function resetAt(_this__u8e3s4, index) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4[index] = null;
}
function Companion_3() {
  Companion_instance_3 = this;
  var tmp = this;
  // Inline function 'kotlin.also' call
  var this_0 = ArrayList_init_$Create$_0(0);
  // Inline function 'kotlin.collections.Companion.Empty.<anonymous>' call
  this_0.j3_1 = true;
  tmp.k3_1 = this_0;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 == null)
    new Companion_3();
  return Companion_instance_3;
}
function ArrayList_init_$Init$($this) {
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  ArrayList.call($this, tmp$ret$0);
  return $this;
}
function ArrayList_init_$Create$() {
  return ArrayList_init_$Init$(objectCreate(protoOf(ArrayList)));
}
function ArrayList_init_$Init$_0(initialCapacity, $this) {
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  ArrayList.call($this, tmp$ret$0);
  // Inline function 'kotlin.require' call
  if (!(initialCapacity >= 0)) {
    // Inline function 'kotlin.collections.ArrayList.<init>.<anonymous>' call
    var message = 'Negative initial capacity: ' + initialCapacity;
    throw IllegalArgumentException_init_$Create$_0(toString_1(message));
  }
  return $this;
}
function ArrayList_init_$Create$_0(initialCapacity) {
  return ArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(ArrayList)));
}
function rangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.collections.ArrayList.rangeCheck.<anonymous>' call
  Companion_instance_6.l3(index, $this.h());
  return index;
}
function insertionRangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.collections.ArrayList.insertionRangeCheck.<anonymous>' call
  Companion_instance_6.m3(index, $this.h());
  return index;
}
function ArrayList(array) {
  Companion_getInstance_3();
  AbstractMutableList.call(this);
  this.i3_1 = array;
  this.j3_1 = false;
}
protoOf(ArrayList).h = function () {
  return this.i3_1.length;
};
protoOf(ArrayList).i = function (index) {
  var tmp = this.i3_1[rangeCheck(this, index)];
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(ArrayList).c = function (element) {
  this.k2();
  // Inline function 'kotlin.js.asDynamic' call
  this.i3_1.push(element);
  this.p2_1 = this.p2_1 + 1 | 0;
  return true;
};
protoOf(ArrayList).r2 = function (index, element) {
  this.k2();
  // Inline function 'kotlin.js.asDynamic' call
  this.i3_1.splice(insertionRangeCheck(this, index), 0, element);
  this.p2_1 = this.p2_1 + 1 | 0;
};
protoOf(ArrayList).q2 = function (index) {
  this.k2();
  rangeCheck(this, index);
  this.p2_1 = this.p2_1 + 1 | 0;
  var tmp;
  if (index === get_lastIndex(this)) {
    // Inline function 'kotlin.js.asDynamic' call
    tmp = this.i3_1.pop();
  } else {
    // Inline function 'kotlin.js.asDynamic' call
    tmp = this.i3_1.splice(index, 1)[0];
  }
  return tmp;
};
protoOf(ArrayList).j2 = function (element) {
  this.k2();
  var inductionVariable = 0;
  var last = this.i3_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (equals(this.i3_1[index], element)) {
        // Inline function 'kotlin.js.asDynamic' call
        this.i3_1.splice(index, 1);
        this.p2_1 = this.p2_1 + 1 | 0;
        return true;
      }
    }
     while (inductionVariable <= last);
  return false;
};
protoOf(ArrayList).s2 = function (element) {
  return indexOf(this.i3_1, element);
};
protoOf(ArrayList).toString = function () {
  return arrayToString(this.i3_1);
};
protoOf(ArrayList).n3 = function () {
  return [].slice.call(this.i3_1);
};
protoOf(ArrayList).toArray = function () {
  return this.n3();
};
protoOf(ArrayList).k2 = function () {
  if (this.j3_1)
    throw UnsupportedOperationException_init_$Create$();
};
function HashMap_init_$Init$(internalMap, $this) {
  AbstractMutableMap.call($this);
  HashMap.call($this);
  $this.g2_1 = internalMap;
  return $this;
}
function HashMap_init_$Init$_0($this) {
  HashMap_init_$Init$(InternalHashMap_init_$Create$(), $this);
  return $this;
}
function HashMap_init_$Create$() {
  return HashMap_init_$Init$_0(objectCreate(protoOf(HashMap)));
}
function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
  HashMap_init_$Init$(InternalHashMap_init_$Create$_1(initialCapacity, loadFactor), $this);
  return $this;
}
function HashMap_init_$Init$_2(initialCapacity, $this) {
  HashMap_init_$Init$_1(initialCapacity, 1.0, $this);
  return $this;
}
protoOf(HashMap).a1 = function () {
  this.g2_1.a1();
};
protoOf(HashMap).r = function (key) {
  return this.g2_1.o3(key);
};
protoOf(HashMap).s = function (value) {
  return this.g2_1.s(value);
};
protoOf(HashMap).a3 = function () {
  return new HashMapKeys(this.g2_1);
};
protoOf(HashMap).b3 = function () {
  return new HashMapValues(this.g2_1);
};
protoOf(HashMap).w = function () {
  var tmp0_elvis_lhs = this.h2_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = new HashMapEntrySet(this.g2_1);
    // Inline function 'kotlin.collections.HashMap.<get-entries>.<anonymous>' call
    this.h2_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(HashMap).t = function (key) {
  return this.g2_1.t(key);
};
protoOf(HashMap).x = function (key, value) {
  return this.g2_1.x(key, value);
};
protoOf(HashMap).y = function (key) {
  return this.g2_1.y(key);
};
protoOf(HashMap).h = function () {
  return this.g2_1.h();
};
protoOf(HashMap).z = function (from) {
  return this.g2_1.z(from);
};
function HashMap() {
  this.h2_1 = null;
}
function HashMapKeys(backing) {
  AbstractMutableSet.call(this);
  this.p3_1 = backing;
}
protoOf(HashMapKeys).h = function () {
  return this.p3_1.h();
};
protoOf(HashMapKeys).j = function () {
  return this.p3_1.h() === 0;
};
protoOf(HashMapKeys).n = function (element) {
  return this.p3_1.o3(element);
};
protoOf(HashMapKeys).a1 = function () {
  return this.p3_1.a1();
};
protoOf(HashMapKeys).c = function (element) {
  throw UnsupportedOperationException_init_$Create$();
};
protoOf(HashMapKeys).e = function () {
  return this.p3_1.q3();
};
protoOf(HashMapKeys).k2 = function () {
  return this.p3_1.r3();
};
function HashMapValues(backing) {
  AbstractMutableCollection.call(this);
  this.s3_1 = backing;
}
protoOf(HashMapValues).h = function () {
  return this.s3_1.h();
};
protoOf(HashMapValues).j = function () {
  return this.s3_1.h() === 0;
};
protoOf(HashMapValues).t3 = function (element) {
  return this.s3_1.s(element);
};
protoOf(HashMapValues).n = function (element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return this.t3((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(HashMapValues).u3 = function (element) {
  throw UnsupportedOperationException_init_$Create$();
};
protoOf(HashMapValues).c = function (element) {
  return this.u3((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(HashMapValues).e = function () {
  return this.s3_1.v3();
};
protoOf(HashMapValues).k2 = function () {
  return this.s3_1.r3();
};
function HashMapEntrySet(backing) {
  HashMapEntrySetBase.call(this, backing);
}
protoOf(HashMapEntrySet).e = function () {
  return this.x3_1.y3();
};
function HashMapEntrySetBase(backing) {
  AbstractMutableSet.call(this);
  this.x3_1 = backing;
}
protoOf(HashMapEntrySetBase).h = function () {
  return this.x3_1.h();
};
protoOf(HashMapEntrySetBase).j = function () {
  return this.x3_1.h() === 0;
};
protoOf(HashMapEntrySetBase).z3 = function (element) {
  return this.x3_1.b4(element);
};
protoOf(HashMapEntrySetBase).n = function (element) {
  if (!(!(element == null) ? isInterface(element, Entry) : false))
    return false;
  return this.z3((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
};
protoOf(HashMapEntrySetBase).a1 = function () {
  return this.x3_1.a1();
};
protoOf(HashMapEntrySetBase).a4 = function (element) {
  throw UnsupportedOperationException_init_$Create$();
};
protoOf(HashMapEntrySetBase).c = function (element) {
  return this.a4((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
};
protoOf(HashMapEntrySetBase).o = function (elements) {
  return this.x3_1.c4(elements);
};
protoOf(HashMapEntrySetBase).k2 = function () {
  return this.x3_1.r3();
};
function HashMapKeysDefault$iterator$1($entryIterator) {
  this.d4_1 = $entryIterator;
}
protoOf(HashMapKeysDefault$iterator$1).f = function () {
  return this.d4_1.f();
};
protoOf(HashMapKeysDefault$iterator$1).g = function () {
  return this.d4_1.g().p();
};
protoOf(HashMapKeysDefault$iterator$1).l2 = function () {
  return this.d4_1.l2();
};
function HashMapKeysDefault(backingMap) {
  AbstractMutableSet.call(this);
  this.e4_1 = backingMap;
}
protoOf(HashMapKeysDefault).f4 = function (element) {
  throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
};
protoOf(HashMapKeysDefault).c = function (element) {
  return this.f4((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(HashMapKeysDefault).a1 = function () {
  return this.e4_1.a1();
};
protoOf(HashMapKeysDefault).o3 = function (element) {
  return this.e4_1.r(element);
};
protoOf(HashMapKeysDefault).n = function (element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return this.o3((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(HashMapKeysDefault).e = function () {
  var entryIterator = this.e4_1.w().e();
  return new HashMapKeysDefault$iterator$1(entryIterator);
};
protoOf(HashMapKeysDefault).h = function () {
  return this.e4_1.h();
};
protoOf(HashMapKeysDefault).k2 = function () {
  return this.e4_1.k2();
};
function HashMapValuesDefault$iterator$1($entryIterator) {
  this.g4_1 = $entryIterator;
}
protoOf(HashMapValuesDefault$iterator$1).f = function () {
  return this.g4_1.f();
};
protoOf(HashMapValuesDefault$iterator$1).g = function () {
  return this.g4_1.g().q();
};
protoOf(HashMapValuesDefault$iterator$1).l2 = function () {
  return this.g4_1.l2();
};
function HashMapValuesDefault(backingMap) {
  AbstractMutableCollection.call(this);
  this.h4_1 = backingMap;
}
protoOf(HashMapValuesDefault).u3 = function (element) {
  throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
};
protoOf(HashMapValuesDefault).c = function (element) {
  return this.u3((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(HashMapValuesDefault).t3 = function (element) {
  return this.h4_1.s(element);
};
protoOf(HashMapValuesDefault).n = function (element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return this.t3((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(HashMapValuesDefault).e = function () {
  var entryIterator = this.h4_1.w().e();
  return new HashMapValuesDefault$iterator$1(entryIterator);
};
protoOf(HashMapValuesDefault).h = function () {
  return this.h4_1.h();
};
protoOf(HashMapValuesDefault).k2 = function () {
  return this.h4_1.k2();
};
function HashSet_init_$Init$(map, $this) {
  AbstractMutableSet.call($this);
  HashSet.call($this);
  $this.i4_1 = map;
  return $this;
}
function HashSet_init_$Init$_0($this) {
  HashSet_init_$Init$(InternalHashMap_init_$Create$(), $this);
  return $this;
}
function HashSet_init_$Create$() {
  return HashSet_init_$Init$_0(objectCreate(protoOf(HashSet)));
}
function HashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
  HashSet_init_$Init$(InternalHashMap_init_$Create$_1(initialCapacity, loadFactor), $this);
  return $this;
}
function HashSet_init_$Init$_2(initialCapacity, $this) {
  HashSet_init_$Init$_1(initialCapacity, 1.0, $this);
  return $this;
}
function HashSet_init_$Create$_0(initialCapacity) {
  return HashSet_init_$Init$_2(initialCapacity, objectCreate(protoOf(HashSet)));
}
protoOf(HashSet).c = function (element) {
  return this.i4_1.x(element, true) == null;
};
protoOf(HashSet).a1 = function () {
  this.i4_1.a1();
};
protoOf(HashSet).n = function (element) {
  return this.i4_1.o3(element);
};
protoOf(HashSet).j = function () {
  return this.i4_1.h() === 0;
};
protoOf(HashSet).e = function () {
  return this.i4_1.q3();
};
protoOf(HashSet).h = function () {
  return this.i4_1.h();
};
function HashSet() {
}
function computeHashSize($this, capacity) {
  return takeHighestOneBit(imul_0(coerceAtLeast(capacity, 1), 3));
}
function computeShift($this, hashSize) {
  // Inline function 'kotlin.countLeadingZeroBits' call
  return clz32(hashSize) + 1 | 0;
}
function checkForComodification($this) {
  if (!($this.t4_1.q4_1 === $this.v4_1))
    throw ConcurrentModificationException_init_$Create$_0('The backing map has been modified after this entry was obtained.');
}
function InternalHashMap_init_$Init$($this) {
  InternalHashMap_init_$Init$_0(8, $this);
  return $this;
}
function InternalHashMap_init_$Create$() {
  return InternalHashMap_init_$Init$(objectCreate(protoOf(InternalHashMap)));
}
function InternalHashMap_init_$Init$_0(initialCapacity, $this) {
  InternalHashMap.call($this, arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_4, initialCapacity)), 2, 0);
  return $this;
}
function InternalHashMap_init_$Create$_0(initialCapacity) {
  return InternalHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(InternalHashMap)));
}
function InternalHashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
  InternalHashMap_init_$Init$_0(initialCapacity, $this);
  // Inline function 'kotlin.require' call
  if (!(loadFactor > 0)) {
    // Inline function 'kotlin.collections.InternalHashMap.<init>.<anonymous>' call
    var message = 'Non-positive load factor: ' + loadFactor;
    throw IllegalArgumentException_init_$Create$_0(toString_1(message));
  }
  return $this;
}
function InternalHashMap_init_$Create$_1(initialCapacity, loadFactor) {
  return InternalHashMap_init_$Init$_1(initialCapacity, loadFactor, objectCreate(protoOf(InternalHashMap)));
}
function _get_capacity__a9k9f3($this) {
  return $this.j4_1.length;
}
function _get_hashSize__tftcho($this) {
  return $this.m4_1.length;
}
function registerModification($this) {
  $this.q4_1 = $this.q4_1 + 1 | 0;
}
function ensureExtraCapacity($this, n) {
  if (shouldCompact($this, n)) {
    compact($this, true);
  } else {
    ensureCapacity($this, $this.o4_1 + n | 0);
  }
}
function shouldCompact($this, extraCapacity) {
  var spareCapacity = _get_capacity__a9k9f3($this) - $this.o4_1 | 0;
  var gaps = $this.o4_1 - $this.h() | 0;
  return spareCapacity < extraCapacity && (gaps + spareCapacity | 0) >= extraCapacity && gaps >= (_get_capacity__a9k9f3($this) / 4 | 0);
}
function ensureCapacity($this, minCapacity) {
  if (minCapacity < 0)
    throw RuntimeException_init_$Create$_0('too many elements');
  if (minCapacity > _get_capacity__a9k9f3($this)) {
    var newSize = Companion_instance_6.w4(_get_capacity__a9k9f3($this), minCapacity);
    $this.j4_1 = copyOfUninitializedElements($this.j4_1, newSize);
    var tmp = $this;
    var tmp0_safe_receiver = $this.k4_1;
    tmp.k4_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
    $this.l4_1 = copyOf($this.l4_1, newSize);
    var newHashSize = computeHashSize(Companion_instance_4, newSize);
    if (newHashSize > _get_hashSize__tftcho($this)) {
      rehash($this, newHashSize);
    }
  }
}
function allocateValuesArray($this) {
  var curValuesArray = $this.k4_1;
  if (!(curValuesArray == null))
    return curValuesArray;
  var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
  $this.k4_1 = newValuesArray;
  return newValuesArray;
}
function hash($this, key) {
  return key == null ? 0 : imul_0(hashCode(key), -1640531527) >>> $this.p4_1 | 0;
}
function compact($this, updateHashArray) {
  var i = 0;
  var j = 0;
  var valuesArray = $this.k4_1;
  while (i < $this.o4_1) {
    var hash = $this.l4_1[i];
    if (hash >= 0) {
      $this.j4_1[j] = $this.j4_1[i];
      if (!(valuesArray == null)) {
        valuesArray[j] = valuesArray[i];
      }
      if (updateHashArray) {
        $this.l4_1[j] = hash;
        $this.m4_1[hash] = j + 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
  resetRange($this.j4_1, j, $this.o4_1);
  if (valuesArray == null)
    null;
  else {
    resetRange(valuesArray, j, $this.o4_1);
  }
  $this.o4_1 = j;
}
function rehash($this, newHashSize) {
  registerModification($this);
  if ($this.o4_1 > $this.r4_1) {
    compact($this, false);
  }
  $this.m4_1 = new Int32Array(newHashSize);
  $this.p4_1 = computeShift(Companion_instance_4, newHashSize);
  var i = 0;
  while (i < $this.o4_1) {
    var _unary__edvuaz = i;
    i = _unary__edvuaz + 1 | 0;
    if (!putRehash($this, _unary__edvuaz)) {
      throw IllegalStateException_init_$Create$_0('This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?');
    }
  }
}
function putRehash($this, i) {
  var hash_0 = hash($this, $this.j4_1[i]);
  var probesLeft = $this.n4_1;
  while (true) {
    var index = $this.m4_1[hash_0];
    if (index === 0) {
      $this.m4_1[hash_0] = i + 1 | 0;
      $this.l4_1[i] = hash_0;
      return true;
    }
    probesLeft = probesLeft - 1 | 0;
    if (probesLeft < 0)
      return false;
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
  }
}
function findKey($this, key) {
  var hash_0 = hash($this, key);
  var probesLeft = $this.n4_1;
  while (true) {
    var index = $this.m4_1[hash_0];
    if (index === 0)
      return -1;
    if (index > 0 && equals($this.j4_1[index - 1 | 0], key))
      return index - 1 | 0;
    probesLeft = probesLeft - 1 | 0;
    if (probesLeft < 0)
      return -1;
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
  }
}
function findValue($this, value) {
  var i = $this.o4_1;
  $l$loop: while (true) {
    i = i - 1 | 0;
    if (!(i >= 0)) {
      break $l$loop;
    }
    if ($this.l4_1[i] >= 0 && equals(ensureNotNull($this.k4_1)[i], value))
      return i;
  }
  return -1;
}
function addKey($this, key) {
  $this.r3();
  retry: while (true) {
    var hash_0 = hash($this, key);
    var tentativeMaxProbeDistance = coerceAtMost(imul_0($this.n4_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
    var probeDistance = 0;
    while (true) {
      var index = $this.m4_1[hash_0];
      if (index <= 0) {
        if ($this.o4_1 >= _get_capacity__a9k9f3($this)) {
          ensureExtraCapacity($this, 1);
          continue retry;
        }
        var _unary__edvuaz = $this.o4_1;
        $this.o4_1 = _unary__edvuaz + 1 | 0;
        var putIndex = _unary__edvuaz;
        $this.j4_1[putIndex] = key;
        $this.l4_1[putIndex] = hash_0;
        $this.m4_1[hash_0] = putIndex + 1 | 0;
        $this.r4_1 = $this.r4_1 + 1 | 0;
        registerModification($this);
        if (probeDistance > $this.n4_1)
          $this.n4_1 = probeDistance;
        return putIndex;
      }
      if (equals($this.j4_1[index - 1 | 0], key)) {
        return -index | 0;
      }
      probeDistance = probeDistance + 1 | 0;
      if (probeDistance > tentativeMaxProbeDistance) {
        rehash($this, imul_0(_get_hashSize__tftcho($this), 2));
        continue retry;
      }
      var _unary__edvuaz_0 = hash_0;
      hash_0 = _unary__edvuaz_0 - 1 | 0;
      if (_unary__edvuaz_0 === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
}
function removeEntryAt($this, index) {
  resetAt($this.j4_1, index);
  var tmp0_safe_receiver = $this.k4_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    resetAt(tmp0_safe_receiver, index);
  }
  removeHashAt($this, $this.l4_1[index]);
  $this.l4_1[index] = -1;
  $this.r4_1 = $this.r4_1 - 1 | 0;
  registerModification($this);
}
function removeHashAt($this, removedHash) {
  var hash_0 = removedHash;
  var hole = removedHash;
  var probeDistance = 0;
  var patchAttemptsLeft = coerceAtMost(imul_0($this.n4_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
  while (true) {
    var _unary__edvuaz = hash_0;
    hash_0 = _unary__edvuaz - 1 | 0;
    if (_unary__edvuaz === 0)
      hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    probeDistance = probeDistance + 1 | 0;
    if (probeDistance > $this.n4_1) {
      $this.m4_1[hole] = 0;
      return Unit_instance;
    }
    var index = $this.m4_1[hash_0];
    if (index === 0) {
      $this.m4_1[hole] = 0;
      return Unit_instance;
    }
    if (index < 0) {
      $this.m4_1[hole] = -1;
      hole = hash_0;
      probeDistance = 0;
    } else {
      var otherHash = hash($this, $this.j4_1[index - 1 | 0]);
      if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
        $this.m4_1[hole] = index;
        $this.l4_1[index - 1 | 0] = hole;
        hole = hash_0;
        probeDistance = 0;
      }
    }
    patchAttemptsLeft = patchAttemptsLeft - 1 | 0;
    if (patchAttemptsLeft < 0) {
      $this.m4_1[hole] = -1;
      return Unit_instance;
    }
  }
}
function contentEquals($this, other) {
  return $this.r4_1 === other.h() && $this.c4(other.w());
}
function putEntry($this, entry) {
  var index = addKey($this, entry.p());
  var valuesArray = allocateValuesArray($this);
  if (index >= 0) {
    valuesArray[index] = entry.q();
    return true;
  }
  var oldValue = valuesArray[(-index | 0) - 1 | 0];
  if (!equals(entry.q(), oldValue)) {
    valuesArray[(-index | 0) - 1 | 0] = entry.q();
    return true;
  }
  return false;
}
function putAllEntries($this, from) {
  if (from.j())
    return false;
  ensureExtraCapacity($this, from.h());
  var it = from.e();
  var updated = false;
  while (it.f()) {
    if (putEntry($this, it.g()))
      updated = true;
  }
  return updated;
}
function Companion_4() {
  this.x4_1 = -1640531527;
  this.y4_1 = 8;
  this.z4_1 = 2;
  this.a5_1 = -1;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function Itr(map) {
  this.b5_1 = map;
  this.c5_1 = 0;
  this.d5_1 = -1;
  this.e5_1 = this.b5_1.q4_1;
  this.f5();
}
protoOf(Itr).f5 = function () {
  while (this.c5_1 < this.b5_1.o4_1 && this.b5_1.l4_1[this.c5_1] < 0) {
    this.c5_1 = this.c5_1 + 1 | 0;
  }
};
protoOf(Itr).f = function () {
  return this.c5_1 < this.b5_1.o4_1;
};
protoOf(Itr).l2 = function () {
  this.g5();
  // Inline function 'kotlin.check' call
  if (!!(this.d5_1 === -1)) {
    // Inline function 'kotlin.collections.Itr.remove.<anonymous>' call
    var message = 'Call next() before removing element from the iterator.';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  this.b5_1.r3();
  removeEntryAt(this.b5_1, this.d5_1);
  this.d5_1 = -1;
  this.e5_1 = this.b5_1.q4_1;
};
protoOf(Itr).g5 = function () {
  if (!(this.b5_1.q4_1 === this.e5_1))
    throw ConcurrentModificationException_init_$Create$();
};
function KeysItr(map) {
  Itr.call(this, map);
}
protoOf(KeysItr).g = function () {
  this.g5();
  if (this.c5_1 >= this.b5_1.o4_1)
    throw NoSuchElementException_init_$Create$();
  var tmp = this;
  var _unary__edvuaz = this.c5_1;
  this.c5_1 = _unary__edvuaz + 1 | 0;
  tmp.d5_1 = _unary__edvuaz;
  var result = this.b5_1.j4_1[this.d5_1];
  this.f5();
  return result;
};
function ValuesItr(map) {
  Itr.call(this, map);
}
protoOf(ValuesItr).g = function () {
  this.g5();
  if (this.c5_1 >= this.b5_1.o4_1)
    throw NoSuchElementException_init_$Create$();
  var tmp = this;
  var _unary__edvuaz = this.c5_1;
  this.c5_1 = _unary__edvuaz + 1 | 0;
  tmp.d5_1 = _unary__edvuaz;
  var result = ensureNotNull(this.b5_1.k4_1)[this.d5_1];
  this.f5();
  return result;
};
function EntriesItr(map) {
  Itr.call(this, map);
}
protoOf(EntriesItr).g = function () {
  this.g5();
  if (this.c5_1 >= this.b5_1.o4_1)
    throw NoSuchElementException_init_$Create$();
  var tmp = this;
  var _unary__edvuaz = this.c5_1;
  this.c5_1 = _unary__edvuaz + 1 | 0;
  tmp.d5_1 = _unary__edvuaz;
  var result = new EntryRef(this.b5_1, this.d5_1);
  this.f5();
  return result;
};
protoOf(EntriesItr).t5 = function () {
  if (this.c5_1 >= this.b5_1.o4_1)
    throw NoSuchElementException_init_$Create$();
  var tmp = this;
  var _unary__edvuaz = this.c5_1;
  this.c5_1 = _unary__edvuaz + 1 | 0;
  tmp.d5_1 = _unary__edvuaz;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.b5_1.j4_1[this.d5_1];
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_0 = ensureNotNull(this.b5_1.k4_1)[this.d5_1];
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
  var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
  this.f5();
  return result;
};
protoOf(EntriesItr).u5 = function (sb) {
  if (this.c5_1 >= this.b5_1.o4_1)
    throw NoSuchElementException_init_$Create$();
  var tmp = this;
  var _unary__edvuaz = this.c5_1;
  this.c5_1 = _unary__edvuaz + 1 | 0;
  tmp.d5_1 = _unary__edvuaz;
  var key = this.b5_1.j4_1[this.d5_1];
  if (equals(key, this.b5_1))
    sb.x5('(this Map)');
  else
    sb.w5(key);
  sb.y5(_Char___init__impl__6a9atx(61));
  var value = ensureNotNull(this.b5_1.k4_1)[this.d5_1];
  if (equals(value, this.b5_1))
    sb.x5('(this Map)');
  else
    sb.w5(value);
  this.f5();
};
function EntryRef(map, index) {
  this.t4_1 = map;
  this.u4_1 = index;
  this.v4_1 = this.t4_1.q4_1;
}
protoOf(EntryRef).p = function () {
  checkForComodification(this);
  return this.t4_1.j4_1[this.u4_1];
};
protoOf(EntryRef).q = function () {
  checkForComodification(this);
  return ensureNotNull(this.t4_1.k4_1)[this.u4_1];
};
protoOf(EntryRef).equals = function (other) {
  var tmp;
  var tmp_0;
  if (!(other == null) ? isInterface(other, Entry) : false) {
    tmp_0 = equals(other.p(), this.p());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = equals(other.q(), this.q());
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(EntryRef).hashCode = function () {
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.p();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_0 = this.q();
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
  return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
};
protoOf(EntryRef).toString = function () {
  return toString_0(this.p()) + '=' + toString_0(this.q());
};
function InternalHashMap(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
  this.j4_1 = keysArray;
  this.k4_1 = valuesArray;
  this.l4_1 = presenceArray;
  this.m4_1 = hashArray;
  this.n4_1 = maxProbeDistance;
  this.o4_1 = length;
  this.p4_1 = computeShift(Companion_instance_4, _get_hashSize__tftcho(this));
  this.q4_1 = 0;
  this.r4_1 = 0;
  this.s4_1 = false;
}
protoOf(InternalHashMap).h = function () {
  return this.r4_1;
};
protoOf(InternalHashMap).z5 = function () {
  this.r3();
  this.s4_1 = true;
};
protoOf(InternalHashMap).s = function (value) {
  return findValue(this, value) >= 0;
};
protoOf(InternalHashMap).t = function (key) {
  var index = findKey(this, key);
  if (index < 0)
    return null;
  return ensureNotNull(this.k4_1)[index];
};
protoOf(InternalHashMap).o3 = function (key) {
  return findKey(this, key) >= 0;
};
protoOf(InternalHashMap).x = function (key, value) {
  var index = addKey(this, key);
  var valuesArray = allocateValuesArray(this);
  if (index < 0) {
    var oldValue = valuesArray[(-index | 0) - 1 | 0];
    valuesArray[(-index | 0) - 1 | 0] = value;
    return oldValue;
  } else {
    valuesArray[index] = value;
    return null;
  }
};
protoOf(InternalHashMap).z = function (from) {
  this.r3();
  putAllEntries(this, from.w());
};
protoOf(InternalHashMap).y = function (key) {
  this.r3();
  var index = findKey(this, key);
  if (index < 0)
    return null;
  var oldValue = ensureNotNull(this.k4_1)[index];
  removeEntryAt(this, index);
  return oldValue;
};
protoOf(InternalHashMap).a1 = function () {
  this.r3();
  var inductionVariable = 0;
  var last = this.o4_1 - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var hash = this.l4_1[i];
      if (hash >= 0) {
        this.m4_1[hash] = 0;
        this.l4_1[i] = -1;
      }
    }
     while (!(i === last));
  resetRange(this.j4_1, 0, this.o4_1);
  var tmp0_safe_receiver = this.k4_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    resetRange(tmp0_safe_receiver, 0, this.o4_1);
  }
  this.r4_1 = 0;
  this.o4_1 = 0;
  registerModification(this);
};
protoOf(InternalHashMap).equals = function (other) {
  var tmp;
  if (other === this) {
    tmp = true;
  } else {
    var tmp_0;
    if (!(other == null) ? isInterface(other, KtMap_0) : false) {
      tmp_0 = contentEquals(this, other);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(InternalHashMap).hashCode = function () {
  var result = 0;
  var it = this.y3();
  while (it.f()) {
    result = result + it.t5() | 0;
  }
  return result;
};
protoOf(InternalHashMap).toString = function () {
  var sb = StringBuilder_init_$Create$(2 + imul_0(this.r4_1, 3) | 0);
  sb.x5('{');
  var i = 0;
  var it = this.y3();
  while (it.f()) {
    if (i > 0) {
      sb.x5(', ');
    }
    it.u5(sb);
    i = i + 1 | 0;
  }
  sb.x5('}');
  return sb.toString();
};
protoOf(InternalHashMap).r3 = function () {
  if (this.s4_1)
    throw UnsupportedOperationException_init_$Create$();
};
protoOf(InternalHashMap).b4 = function (entry) {
  var index = findKey(this, entry.p());
  if (index < 0)
    return false;
  return equals(ensureNotNull(this.k4_1)[index], entry.q());
};
protoOf(InternalHashMap).a6 = function (entry) {
  return this.b4(isInterface(entry, Entry) ? entry : THROW_CCE());
};
protoOf(InternalHashMap).q3 = function () {
  return new KeysItr(this);
};
protoOf(InternalHashMap).v3 = function () {
  return new ValuesItr(this);
};
protoOf(InternalHashMap).y3 = function () {
  return new EntriesItr(this);
};
function InternalMap() {
}
function LinkedHashMap_init_$Init$($this) {
  HashMap_init_$Init$_0($this);
  LinkedHashMap.call($this);
  return $this;
}
function LinkedHashMap_init_$Create$() {
  return LinkedHashMap_init_$Init$(objectCreate(protoOf(LinkedHashMap)));
}
function LinkedHashMap_init_$Init$_0(initialCapacity, $this) {
  HashMap_init_$Init$_2(initialCapacity, $this);
  LinkedHashMap.call($this);
  return $this;
}
function LinkedHashMap_init_$Create$_0(initialCapacity) {
  return LinkedHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(LinkedHashMap)));
}
function LinkedHashMap_init_$Init$_1(internalMap, $this) {
  HashMap_init_$Init$(internalMap, $this);
  LinkedHashMap.call($this);
  return $this;
}
function LinkedHashMap_init_$Create$_1(internalMap) {
  return LinkedHashMap_init_$Init$_1(internalMap, objectCreate(protoOf(LinkedHashMap)));
}
function EmptyHolder() {
  EmptyHolder_instance = this;
  var tmp = this;
  // Inline function 'kotlin.also' call
  var this_0 = InternalHashMap_init_$Create$_0(0);
  // Inline function 'kotlin.collections.EmptyHolder.value.<anonymous>' call
  this_0.z5();
  tmp.b6_1 = LinkedHashMap_init_$Create$_1(this_0);
}
var EmptyHolder_instance;
function EmptyHolder_getInstance() {
  if (EmptyHolder_instance == null)
    new EmptyHolder();
  return EmptyHolder_instance;
}
protoOf(LinkedHashMap).b2 = function () {
  this.g2_1.z5();
  var tmp;
  if (this.h() > 0) {
    tmp = this;
  } else {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = EmptyHolder_getInstance().b6_1;
  }
  return tmp;
};
protoOf(LinkedHashMap).k2 = function () {
  return this.g2_1.r3();
};
function LinkedHashMap() {
}
function LinkedHashSet_init_$Init$($this) {
  HashSet_init_$Init$_0($this);
  LinkedHashSet.call($this);
  return $this;
}
function LinkedHashSet_init_$Create$() {
  return LinkedHashSet_init_$Init$(objectCreate(protoOf(LinkedHashSet)));
}
function LinkedHashSet_init_$Init$_0(initialCapacity, loadFactor, $this) {
  HashSet_init_$Init$_1(initialCapacity, loadFactor, $this);
  LinkedHashSet.call($this);
  return $this;
}
function LinkedHashSet_init_$Init$_1(initialCapacity, $this) {
  LinkedHashSet_init_$Init$_0(initialCapacity, 1.0, $this);
  return $this;
}
function LinkedHashSet_init_$Create$_0(initialCapacity) {
  return LinkedHashSet_init_$Init$_1(initialCapacity, objectCreate(protoOf(LinkedHashSet)));
}
protoOf(LinkedHashSet).k2 = function () {
  return this.i4_1.r3();
};
function LinkedHashSet() {
}
function Exception_init_$Init$($this) {
  extendThrowable($this);
  Exception.call($this);
  return $this;
}
function Exception_init_$Create$() {
  var tmp = Exception_init_$Init$(objectCreate(protoOf(Exception)));
  captureStack(tmp, Exception_init_$Create$);
  return tmp;
}
function Exception_init_$Init$_0(message, $this) {
  extendThrowable($this, message);
  Exception.call($this);
  return $this;
}
function Exception_init_$Create$_0(message) {
  var tmp = Exception_init_$Init$_0(message, objectCreate(protoOf(Exception)));
  captureStack(tmp, Exception_init_$Create$_0);
  return tmp;
}
function Exception() {
  captureStack(this, Exception);
}
function IllegalArgumentException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  IllegalArgumentException.call($this);
  return $this;
}
function IllegalArgumentException_init_$Create$() {
  var tmp = IllegalArgumentException_init_$Init$(objectCreate(protoOf(IllegalArgumentException)));
  captureStack(tmp, IllegalArgumentException_init_$Create$);
  return tmp;
}
function IllegalArgumentException_init_$Init$_0(message, $this) {
  RuntimeException_init_$Init$_0(message, $this);
  IllegalArgumentException.call($this);
  return $this;
}
function IllegalArgumentException_init_$Create$_0(message) {
  var tmp = IllegalArgumentException_init_$Init$_0(message, objectCreate(protoOf(IllegalArgumentException)));
  captureStack(tmp, IllegalArgumentException_init_$Create$_0);
  return tmp;
}
function IllegalArgumentException() {
  captureStack(this, IllegalArgumentException);
}
function IllegalStateException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  IllegalStateException.call($this);
  return $this;
}
function IllegalStateException_init_$Create$() {
  var tmp = IllegalStateException_init_$Init$(objectCreate(protoOf(IllegalStateException)));
  captureStack(tmp, IllegalStateException_init_$Create$);
  return tmp;
}
function IllegalStateException_init_$Init$_0(message, $this) {
  RuntimeException_init_$Init$_0(message, $this);
  IllegalStateException.call($this);
  return $this;
}
function IllegalStateException_init_$Create$_0(message) {
  var tmp = IllegalStateException_init_$Init$_0(message, objectCreate(protoOf(IllegalStateException)));
  captureStack(tmp, IllegalStateException_init_$Create$_0);
  return tmp;
}
function IllegalStateException() {
  captureStack(this, IllegalStateException);
}
function UnsupportedOperationException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  UnsupportedOperationException.call($this);
  return $this;
}
function UnsupportedOperationException_init_$Create$() {
  var tmp = UnsupportedOperationException_init_$Init$(objectCreate(protoOf(UnsupportedOperationException)));
  captureStack(tmp, UnsupportedOperationException_init_$Create$);
  return tmp;
}
function UnsupportedOperationException_init_$Init$_0(message, $this) {
  RuntimeException_init_$Init$_0(message, $this);
  UnsupportedOperationException.call($this);
  return $this;
}
function UnsupportedOperationException_init_$Create$_0(message) {
  var tmp = UnsupportedOperationException_init_$Init$_0(message, objectCreate(protoOf(UnsupportedOperationException)));
  captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
  return tmp;
}
function UnsupportedOperationException() {
  captureStack(this, UnsupportedOperationException);
}
function RuntimeException_init_$Init$($this) {
  Exception_init_$Init$($this);
  RuntimeException.call($this);
  return $this;
}
function RuntimeException_init_$Create$() {
  var tmp = RuntimeException_init_$Init$(objectCreate(protoOf(RuntimeException)));
  captureStack(tmp, RuntimeException_init_$Create$);
  return tmp;
}
function RuntimeException_init_$Init$_0(message, $this) {
  Exception_init_$Init$_0(message, $this);
  RuntimeException.call($this);
  return $this;
}
function RuntimeException_init_$Create$_0(message) {
  var tmp = RuntimeException_init_$Init$_0(message, objectCreate(protoOf(RuntimeException)));
  captureStack(tmp, RuntimeException_init_$Create$_0);
  return tmp;
}
function RuntimeException() {
  captureStack(this, RuntimeException);
}
function NoSuchElementException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  NoSuchElementException.call($this);
  return $this;
}
function NoSuchElementException_init_$Create$() {
  var tmp = NoSuchElementException_init_$Init$(objectCreate(protoOf(NoSuchElementException)));
  captureStack(tmp, NoSuchElementException_init_$Create$);
  return tmp;
}
function NoSuchElementException_init_$Init$_0(message, $this) {
  RuntimeException_init_$Init$_0(message, $this);
  NoSuchElementException.call($this);
  return $this;
}
function NoSuchElementException_init_$Create$_0(message) {
  var tmp = NoSuchElementException_init_$Init$_0(message, objectCreate(protoOf(NoSuchElementException)));
  captureStack(tmp, NoSuchElementException_init_$Create$_0);
  return tmp;
}
function NoSuchElementException() {
  captureStack(this, NoSuchElementException);
}
function Error_init_$Init$($this) {
  extendThrowable($this);
  Error_0.call($this);
  return $this;
}
function Error_init_$Create$() {
  var tmp = Error_init_$Init$(objectCreate(protoOf(Error_0)));
  captureStack(tmp, Error_init_$Create$);
  return tmp;
}
function Error_init_$Init$_0(message, cause, $this) {
  extendThrowable($this, message, cause);
  Error_0.call($this);
  return $this;
}
function Error_0() {
  captureStack(this, Error_0);
}
function IndexOutOfBoundsException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  IndexOutOfBoundsException.call($this);
  return $this;
}
function IndexOutOfBoundsException_init_$Create$() {
  var tmp = IndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(IndexOutOfBoundsException)));
  captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
  return tmp;
}
function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
  RuntimeException_init_$Init$_0(message, $this);
  IndexOutOfBoundsException.call($this);
  return $this;
}
function IndexOutOfBoundsException_init_$Create$_0(message) {
  var tmp = IndexOutOfBoundsException_init_$Init$_0(message, objectCreate(protoOf(IndexOutOfBoundsException)));
  captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
  return tmp;
}
function IndexOutOfBoundsException() {
  captureStack(this, IndexOutOfBoundsException);
}
function AssertionError_init_$Init$($this) {
  Error_init_$Init$($this);
  AssertionError.call($this);
  return $this;
}
function AssertionError_init_$Create$() {
  var tmp = AssertionError_init_$Init$(objectCreate(protoOf(AssertionError)));
  captureStack(tmp, AssertionError_init_$Create$);
  return tmp;
}
function AssertionError_init_$Init$_0(message, $this) {
  var tmp = message == null ? null : toString_1(message);
  Error_init_$Init$_0(tmp, message instanceof Error ? message : null, $this);
  AssertionError.call($this);
  return $this;
}
function AssertionError_init_$Create$_0(message) {
  var tmp = AssertionError_init_$Init$_0(message, objectCreate(protoOf(AssertionError)));
  captureStack(tmp, AssertionError_init_$Create$_0);
  return tmp;
}
function AssertionError() {
  captureStack(this, AssertionError);
}
function ConcurrentModificationException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  ConcurrentModificationException.call($this);
  return $this;
}
function ConcurrentModificationException_init_$Create$() {
  var tmp = ConcurrentModificationException_init_$Init$(objectCreate(protoOf(ConcurrentModificationException)));
  captureStack(tmp, ConcurrentModificationException_init_$Create$);
  return tmp;
}
function ConcurrentModificationException_init_$Init$_0(message, $this) {
  RuntimeException_init_$Init$_0(message, $this);
  ConcurrentModificationException.call($this);
  return $this;
}
function ConcurrentModificationException_init_$Create$_0(message) {
  var tmp = ConcurrentModificationException_init_$Init$_0(message, objectCreate(protoOf(ConcurrentModificationException)));
  captureStack(tmp, ConcurrentModificationException_init_$Create$_0);
  return tmp;
}
function ConcurrentModificationException() {
  captureStack(this, ConcurrentModificationException);
}
function NullPointerException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  NullPointerException.call($this);
  return $this;
}
function NullPointerException_init_$Create$() {
  var tmp = NullPointerException_init_$Init$(objectCreate(protoOf(NullPointerException)));
  captureStack(tmp, NullPointerException_init_$Create$);
  return tmp;
}
function NullPointerException() {
  captureStack(this, NullPointerException);
}
function NoWhenBranchMatchedException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  NoWhenBranchMatchedException.call($this);
  return $this;
}
function NoWhenBranchMatchedException_init_$Create$() {
  var tmp = NoWhenBranchMatchedException_init_$Init$(objectCreate(protoOf(NoWhenBranchMatchedException)));
  captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
  return tmp;
}
function NoWhenBranchMatchedException() {
  captureStack(this, NoWhenBranchMatchedException);
}
function ClassCastException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  ClassCastException.call($this);
  return $this;
}
function ClassCastException_init_$Create$() {
  var tmp = ClassCastException_init_$Init$(objectCreate(protoOf(ClassCastException)));
  captureStack(tmp, ClassCastException_init_$Create$);
  return tmp;
}
function ClassCastException() {
  captureStack(this, ClassCastException);
}
function fillFrom(src, dst) {
  var srcLen = src.length;
  var dstLen = dst.length;
  var index = 0;
  // Inline function 'kotlin.js.unsafeCast' call
  var arr = dst;
  while (index < srcLen && index < dstLen) {
    var tmp = index;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    arr[tmp] = src[_unary__edvuaz];
  }
  return dst;
}
function arrayCopyResize(source, newSize, defaultValue) {
  // Inline function 'kotlin.js.unsafeCast' call
  var result = source.slice(0, newSize);
  // Inline function 'kotlin.copyArrayType' call
  if (source.$type$ !== undefined) {
    result.$type$ = source.$type$;
  }
  var index = source.length;
  if (newSize > index) {
    // Inline function 'kotlin.js.asDynamic' call
    result.length = newSize;
    while (index < newSize) {
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      result[_unary__edvuaz] = defaultValue;
    }
  }
  return result;
}
function reset(_this__u8e3s4) {
  _this__u8e3s4.lastIndex = 0;
}
function StringBuilder_init_$Init$(capacity, $this) {
  StringBuilder_init_$Init$_0($this);
  return $this;
}
function StringBuilder_init_$Create$(capacity) {
  return StringBuilder_init_$Init$(capacity, objectCreate(protoOf(StringBuilder)));
}
function StringBuilder_init_$Init$_0($this) {
  StringBuilder.call($this, '');
  return $this;
}
function StringBuilder_init_$Create$_0() {
  return StringBuilder_init_$Init$_0(objectCreate(protoOf(StringBuilder)));
}
function StringBuilder(content) {
  this.v5_1 = content;
}
protoOf(StringBuilder).a = function () {
  // Inline function 'kotlin.js.asDynamic' call
  return this.v5_1.length;
};
protoOf(StringBuilder).b = function (index) {
  // Inline function 'kotlin.text.getOrElse' call
  var this_0 = this.v5_1;
  var tmp;
  if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
    tmp = charSequenceGet(this_0, index);
  } else {
    throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', length: ' + this.a() + '}');
  }
  return tmp;
};
protoOf(StringBuilder).y5 = function (value) {
  this.v5_1 = this.v5_1 + toString(value);
  return this;
};
protoOf(StringBuilder).d = function (value) {
  this.v5_1 = this.v5_1 + toString_0(value);
  return this;
};
protoOf(StringBuilder).w5 = function (value) {
  this.v5_1 = this.v5_1 + toString_0(value);
  return this;
};
protoOf(StringBuilder).x5 = function (value) {
  var tmp = this;
  var tmp_0 = this.v5_1;
  tmp.v5_1 = tmp_0 + (value == null ? 'null' : value);
  return this;
};
protoOf(StringBuilder).toString = function () {
  return this.v5_1;
};
function checkRadix(radix) {
  if (!(2 <= radix ? radix <= 36 : false)) {
    throw IllegalArgumentException_init_$Create$_0('radix ' + radix + ' was not in valid range 2..36');
  }
  return radix;
}
function digitOf(char, radix) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.text.digitOf.<anonymous>' call
  var it = Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(57)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(48)) : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(90)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(97)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(122)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(97)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(128)) < 0 ? -1 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65313)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65338)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65313)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65345)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65370)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65345)) + 10 | 0 : digitToIntImpl(char);
  return it >= radix ? -1 : it;
}
function Regex_init_$Init$(pattern, option, $this) {
  Regex.call($this, pattern, setOf(option));
  return $this;
}
function Regex_init_$Create$(pattern, option) {
  return Regex_init_$Init$(pattern, option, objectCreate(protoOf(Regex)));
}
function Regex_init_$Init$_0(pattern, $this) {
  Regex.call($this, pattern, emptySet());
  return $this;
}
function Regex_init_$Create$_0(pattern) {
  return Regex_init_$Init$_0(pattern, objectCreate(protoOf(Regex)));
}
function Companion_5() {
  Companion_instance_5 = this;
  this.f6_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
  this.g6_1 = new RegExp('[\\\\$]', 'g');
  this.h6_1 = new RegExp('\\$', 'g');
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 == null)
    new Companion_5();
  return Companion_instance_5;
}
function Regex(pattern, options) {
  Companion_getInstance_5();
  this.i6_1 = pattern;
  this.j6_1 = toSet(options);
  this.k6_1 = new RegExp(pattern, toFlags(options, 'gu'));
  this.l6_1 = null;
  this.m6_1 = null;
}
protoOf(Regex).n6 = function (input) {
  reset(this.k6_1);
  var match = this.k6_1.exec(toString_1(input));
  return !(match == null) && match.index === 0 && this.k6_1.lastIndex === charSequenceLength(input);
};
protoOf(Regex).toString = function () {
  return this.k6_1.toString();
};
var RegexOption_IGNORE_CASE_instance;
var RegexOption_MULTILINE_instance;
var RegexOption_entriesInitialized;
function RegexOption_initEntries() {
  if (RegexOption_entriesInitialized)
    return Unit_instance;
  RegexOption_entriesInitialized = true;
  RegexOption_IGNORE_CASE_instance = new RegexOption('IGNORE_CASE', 0, 'i');
  RegexOption_MULTILINE_instance = new RegexOption('MULTILINE', 1, 'm');
}
function RegexOption(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.q6_1 = value;
}
function toFlags(_this__u8e3s4, prepend) {
  return joinToString_0(_this__u8e3s4, '', prepend, VOID, VOID, VOID, toFlags$lambda);
}
function toFlags$lambda(it) {
  return it.q6_1;
}
function RegexOption_IGNORE_CASE_getInstance() {
  RegexOption_initEntries();
  return RegexOption_IGNORE_CASE_instance;
}
var DurationUnit_NANOSECONDS_instance;
var DurationUnit_MICROSECONDS_instance;
var DurationUnit_MILLISECONDS_instance;
var DurationUnit_SECONDS_instance;
var DurationUnit_MINUTES_instance;
var DurationUnit_HOURS_instance;
var DurationUnit_DAYS_instance;
var DurationUnit_entriesInitialized;
function DurationUnit_initEntries() {
  if (DurationUnit_entriesInitialized)
    return Unit_instance;
  DurationUnit_entriesInitialized = true;
  DurationUnit_NANOSECONDS_instance = new DurationUnit('NANOSECONDS', 0, 1.0);
  DurationUnit_MICROSECONDS_instance = new DurationUnit('MICROSECONDS', 1, 1000.0);
  DurationUnit_MILLISECONDS_instance = new DurationUnit('MILLISECONDS', 2, 1000000.0);
  DurationUnit_SECONDS_instance = new DurationUnit('SECONDS', 3, 1.0E9);
  DurationUnit_MINUTES_instance = new DurationUnit('MINUTES', 4, 6.0E10);
  DurationUnit_HOURS_instance = new DurationUnit('HOURS', 5, 3.6E12);
  DurationUnit_DAYS_instance = new DurationUnit('DAYS', 6, 8.64E13);
}
function DurationUnit(name, ordinal, scale) {
  Enum.call(this, name, ordinal);
  this.t6_1 = scale;
}
function convertDurationUnit(value, sourceUnit, targetUnit) {
  var sourceCompareTarget = compareTo(sourceUnit.t6_1, targetUnit.t6_1);
  var tmp;
  if (sourceCompareTarget > 0) {
    var scale = numberToLong(sourceUnit.t6_1 / targetUnit.t6_1);
    var result = value.m1(scale);
    tmp = result.n1(scale).equals(value) ? result : value.m(new Long(0, 0)) > 0 ? new Long(-1, 2147483647) : new Long(0, -2147483648);
  } else if (sourceCompareTarget < 0) {
    tmp = value.n1(numberToLong(targetUnit.t6_1 / sourceUnit.t6_1));
  } else {
    tmp = value;
  }
  return tmp;
}
function convertDurationUnitOverflow(value, sourceUnit, targetUnit) {
  var sourceCompareTarget = compareTo(sourceUnit.t6_1, targetUnit.t6_1);
  return sourceCompareTarget > 0 ? value.m1(numberToLong(sourceUnit.t6_1 / targetUnit.t6_1)) : sourceCompareTarget < 0 ? value.n1(numberToLong(targetUnit.t6_1 / sourceUnit.t6_1)) : value;
}
function DurationUnit_NANOSECONDS_getInstance() {
  DurationUnit_initEntries();
  return DurationUnit_NANOSECONDS_instance;
}
function DurationUnit_MILLISECONDS_getInstance() {
  DurationUnit_initEntries();
  return DurationUnit_MILLISECONDS_instance;
}
function DurationUnit_SECONDS_getInstance() {
  DurationUnit_initEntries();
  return DurationUnit_SECONDS_instance;
}
function AbstractCollection$toString$lambda(this$0) {
  return function (it) {
    return it === this$0 ? '(this Collection)' : toString_0(it);
  };
}
function AbstractCollection() {
}
protoOf(AbstractCollection).n = function (element) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(this, Collection)) {
      tmp = this.j();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = this.e();
    while (_iterator__ex2g4s.f()) {
      var element_0 = _iterator__ex2g4s.g();
      // Inline function 'kotlin.collections.AbstractCollection.contains.<anonymous>' call
      if (equals(element_0, element)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
};
protoOf(AbstractCollection).o = function (elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.j();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = elements.e();
    while (_iterator__ex2g4s.f()) {
      var element = _iterator__ex2g4s.g();
      // Inline function 'kotlin.collections.AbstractCollection.containsAll.<anonymous>' call
      if (!this.n(element)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(AbstractCollection).j = function () {
  return this.h() === 0;
};
protoOf(AbstractCollection).toString = function () {
  return joinToString_0(this, ', ', '[', ']', VOID, VOID, AbstractCollection$toString$lambda(this));
};
protoOf(AbstractCollection).toArray = function () {
  return collectionToArray(this);
};
function IteratorImpl_0($outer) {
  this.v6_1 = $outer;
  this.u6_1 = 0;
}
protoOf(IteratorImpl_0).f = function () {
  return this.u6_1 < this.v6_1.h();
};
protoOf(IteratorImpl_0).g = function () {
  if (!this.f())
    throw NoSuchElementException_init_$Create$();
  var _unary__edvuaz = this.u6_1;
  this.u6_1 = _unary__edvuaz + 1 | 0;
  return this.v6_1.i(_unary__edvuaz);
};
function Companion_6() {
  this.t2_1 = 2147483639;
}
protoOf(Companion_6).l3 = function (index, size) {
  if (index < 0 || index >= size) {
    throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
  }
};
protoOf(Companion_6).m3 = function (index, size) {
  if (index < 0 || index > size) {
    throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
  }
};
protoOf(Companion_6).w4 = function (oldCapacity, minCapacity) {
  var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
  if ((newCapacity - minCapacity | 0) < 0)
    newCapacity = minCapacity;
  if ((newCapacity - 2147483639 | 0) > 0)
    newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
  return newCapacity;
};
protoOf(Companion_6).v2 = function (c) {
  var hashCode_0 = 1;
  var _iterator__ex2g4s = c.e();
  while (_iterator__ex2g4s.f()) {
    var e = _iterator__ex2g4s.g();
    var tmp = imul_0(31, hashCode_0);
    var tmp1_elvis_lhs = e == null ? null : hashCode(e);
    hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  return hashCode_0;
};
protoOf(Companion_6).u2 = function (c, other) {
  if (!(c.h() === other.h()))
    return false;
  var otherIterator = other.e();
  var _iterator__ex2g4s = c.e();
  while (_iterator__ex2g4s.f()) {
    var elem = _iterator__ex2g4s.g();
    var elemOther = otherIterator.g();
    if (!equals(elem, elemOther)) {
      return false;
    }
  }
  return true;
};
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function AbstractList() {
  AbstractCollection.call(this);
}
protoOf(AbstractList).e = function () {
  return new IteratorImpl_0(this);
};
protoOf(AbstractList).equals = function (other) {
  if (other === this)
    return true;
  if (!(!(other == null) ? isInterface(other, KtList) : false))
    return false;
  return Companion_instance_6.u2(this, other);
};
protoOf(AbstractList).hashCode = function () {
  return Companion_instance_6.v2(this);
};
function AbstractMap$keys$1$iterator$1($entryIterator) {
  this.w6_1 = $entryIterator;
}
protoOf(AbstractMap$keys$1$iterator$1).f = function () {
  return this.w6_1.f();
};
protoOf(AbstractMap$keys$1$iterator$1).g = function () {
  return this.w6_1.g().p();
};
function AbstractMap$values$1$iterator$1($entryIterator) {
  this.x6_1 = $entryIterator;
}
protoOf(AbstractMap$values$1$iterator$1).f = function () {
  return this.x6_1.f();
};
protoOf(AbstractMap$values$1$iterator$1).g = function () {
  return this.x6_1.g().q();
};
function toString_2($this, entry) {
  return toString_3($this, entry.p()) + '=' + toString_3($this, entry.q());
}
function toString_3($this, o) {
  return o === $this ? '(this Map)' : toString_0(o);
}
function implFindEntry($this, key) {
  var tmp0 = $this.w();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.e();
    while (_iterator__ex2g4s.f()) {
      var element = _iterator__ex2g4s.g();
      // Inline function 'kotlin.collections.AbstractMap.implFindEntry.<anonymous>' call
      if (equals(element.p(), key)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function Companion_7() {
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function AbstractMap$keys$1(this$0) {
  this.y6_1 = this$0;
  AbstractSet.call(this);
}
protoOf(AbstractMap$keys$1).o3 = function (element) {
  return this.y6_1.r(element);
};
protoOf(AbstractMap$keys$1).n = function (element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return this.o3((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(AbstractMap$keys$1).e = function () {
  var entryIterator = this.y6_1.w().e();
  return new AbstractMap$keys$1$iterator$1(entryIterator);
};
protoOf(AbstractMap$keys$1).h = function () {
  return this.y6_1.h();
};
function AbstractMap$toString$lambda(this$0) {
  return function (it) {
    return toString_2(this$0, it);
  };
}
function AbstractMap$values$1(this$0) {
  this.z6_1 = this$0;
  AbstractCollection.call(this);
}
protoOf(AbstractMap$values$1).t3 = function (element) {
  return this.z6_1.s(element);
};
protoOf(AbstractMap$values$1).n = function (element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return this.t3((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(AbstractMap$values$1).e = function () {
  var entryIterator = this.z6_1.w().e();
  return new AbstractMap$values$1$iterator$1(entryIterator);
};
protoOf(AbstractMap$values$1).h = function () {
  return this.z6_1.h();
};
function AbstractMap() {
  this.c3_1 = null;
  this.d3_1 = null;
}
protoOf(AbstractMap).r = function (key) {
  return !(implFindEntry(this, key) == null);
};
protoOf(AbstractMap).s = function (value) {
  var tmp0 = this.w();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.j();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.e();
    while (_iterator__ex2g4s.f()) {
      var element = _iterator__ex2g4s.g();
      // Inline function 'kotlin.collections.AbstractMap.containsValue.<anonymous>' call
      if (equals(element.q(), value)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
};
protoOf(AbstractMap).e3 = function (entry) {
  if (!(!(entry == null) ? isInterface(entry, Entry) : false))
    return false;
  var key = entry.p();
  var value = entry.q();
  // Inline function 'kotlin.collections.get' call
  var ourValue = (isInterface(this, KtMap_0) ? this : THROW_CCE()).t(key);
  if (!equals(value, ourValue)) {
    return false;
  }
  var tmp;
  if (ourValue == null) {
    // Inline function 'kotlin.collections.containsKey' call
    tmp = !(isInterface(this, KtMap_0) ? this : THROW_CCE()).r(key);
  } else {
    tmp = false;
  }
  if (tmp) {
    return false;
  }
  return true;
};
protoOf(AbstractMap).equals = function (other) {
  if (other === this)
    return true;
  if (!(!(other == null) ? isInterface(other, KtMap_0) : false))
    return false;
  if (!(this.h() === other.h()))
    return false;
  var tmp0 = other.w();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.j();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.e();
    while (_iterator__ex2g4s.f()) {
      var element = _iterator__ex2g4s.g();
      // Inline function 'kotlin.collections.AbstractMap.equals.<anonymous>' call
      if (!this.e3(element)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
};
protoOf(AbstractMap).t = function (key) {
  var tmp0_safe_receiver = implFindEntry(this, key);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q();
};
protoOf(AbstractMap).hashCode = function () {
  return hashCode(this.w());
};
protoOf(AbstractMap).j = function () {
  return this.h() === 0;
};
protoOf(AbstractMap).h = function () {
  return this.w().h();
};
protoOf(AbstractMap).u = function () {
  if (this.c3_1 == null) {
    var tmp = this;
    tmp.c3_1 = new AbstractMap$keys$1(this);
  }
  return ensureNotNull(this.c3_1);
};
protoOf(AbstractMap).toString = function () {
  var tmp = this.w();
  return joinToString_0(tmp, ', ', '{', '}', VOID, VOID, AbstractMap$toString$lambda(this));
};
protoOf(AbstractMap).v = function () {
  if (this.d3_1 == null) {
    var tmp = this;
    tmp.d3_1 = new AbstractMap$values$1(this);
  }
  return ensureNotNull(this.d3_1);
};
function Companion_8() {
}
protoOf(Companion_8).g3 = function (c) {
  var hashCode_0 = 0;
  var _iterator__ex2g4s = c.e();
  while (_iterator__ex2g4s.f()) {
    var element = _iterator__ex2g4s.g();
    var tmp = hashCode_0;
    var tmp1_elvis_lhs = element == null ? null : hashCode(element);
    hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  return hashCode_0;
};
protoOf(Companion_8).f3 = function (c, other) {
  if (!(c.h() === other.h()))
    return false;
  return c.o(other);
};
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function AbstractSet() {
  AbstractCollection.call(this);
}
protoOf(AbstractSet).equals = function (other) {
  if (other === this)
    return true;
  if (!(!(other == null) ? isInterface(other, KtSet) : false))
    return false;
  return Companion_instance_8.f3(this, other);
};
protoOf(AbstractSet).hashCode = function () {
  return Companion_instance_8.g3(this);
};
function collectionToArrayCommonImpl(collection) {
  if (collection.j()) {
    // Inline function 'kotlin.emptyArray' call
    return [];
  }
  // Inline function 'kotlin.arrayOfNulls' call
  var size = collection.h();
  var destination = fillArrayVal(Array(size), null);
  var iterator = collection.e();
  var index = 0;
  while (iterator.f()) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    destination[_unary__edvuaz] = iterator.g();
  }
  return destination;
}
function EmptyIterator() {
}
protoOf(EmptyIterator).f = function () {
  return false;
};
protoOf(EmptyIterator).g = function () {
  throw NoSuchElementException_init_$Create$();
};
var EmptyIterator_instance;
function EmptyIterator_getInstance() {
  return EmptyIterator_instance;
}
function get_lastIndex(_this__u8e3s4) {
  return _this__u8e3s4.h() - 1 | 0;
}
function collectionSizeOrDefault(_this__u8e3s4, default_0) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection)) {
    tmp = _this__u8e3s4.h();
  } else {
    tmp = default_0;
  }
  return tmp;
}
function EmptySet() {
  EmptySet_instance = this;
  this.a7_1 = new Long(1993859828, 793161749);
}
protoOf(EmptySet).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, KtSet) : false) {
    tmp = other.j();
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(EmptySet).hashCode = function () {
  return 0;
};
protoOf(EmptySet).toString = function () {
  return '[]';
};
protoOf(EmptySet).h = function () {
  return 0;
};
protoOf(EmptySet).j = function () {
  return true;
};
protoOf(EmptySet).b7 = function (elements) {
  return elements.j();
};
protoOf(EmptySet).o = function (elements) {
  return this.b7(elements);
};
protoOf(EmptySet).e = function () {
  return EmptyIterator_instance;
};
var EmptySet_instance;
function EmptySet_getInstance() {
  if (EmptySet_instance == null)
    new EmptySet();
  return EmptySet_instance;
}
function emptySet() {
  return EmptySet_getInstance();
}
function optimizeReadOnlySet(_this__u8e3s4) {
  switch (_this__u8e3s4.h()) {
    case 0:
      return emptySet();
    case 1:
      return setOf(_this__u8e3s4.e().g());
    default:
      return _this__u8e3s4;
  }
}
function hashSetOf(elements) {
  return toCollection(elements, HashSet_init_$Create$_0(mapCapacity(elements.length)));
}
function enumEntries(entries) {
  return new EnumEntriesList(entries);
}
function EnumEntriesList(entries) {
  AbstractList.call(this);
  this.c7_1 = entries;
}
protoOf(EnumEntriesList).h = function () {
  return this.c7_1.length;
};
protoOf(EnumEntriesList).i = function (index) {
  Companion_instance_6.l3(index, this.c7_1.length);
  return this.c7_1[index];
};
protoOf(EnumEntriesList).d7 = function (element) {
  if (element === null)
    return false;
  var target = getOrNull(this.c7_1, element.c1_1);
  return target === element;
};
protoOf(EnumEntriesList).n = function (element) {
  if (!(element instanceof Enum))
    return false;
  return this.d7(element instanceof Enum ? element : THROW_CCE());
};
function appendElement(_this__u8e3s4, element, transform) {
  if (!(transform == null))
    _this__u8e3s4.d(transform(element));
  else {
    if (element == null ? true : isCharSequence(element))
      _this__u8e3s4.d(element);
    else {
      if (element instanceof Char)
        _this__u8e3s4.y5(element.e7_1);
      else {
        _this__u8e3s4.d(toString_1(element));
      }
    }
  }
}
function toIntOrNull(_this__u8e3s4) {
  return toIntOrNull_0(_this__u8e3s4, 10);
}
function toIntOrNull_0(_this__u8e3s4, radix) {
  checkRadix(radix);
  var length = _this__u8e3s4.length;
  if (length === 0)
    return null;
  var start;
  var isNegative;
  var limit;
  var firstChar = charSequenceGet(_this__u8e3s4, 0);
  if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
    if (length === 1)
      return null;
    start = 1;
    if (firstChar === _Char___init__impl__6a9atx(45)) {
      isNegative = true;
      limit = -2147483648;
    } else if (firstChar === _Char___init__impl__6a9atx(43)) {
      isNegative = false;
      limit = -2147483647;
    } else
      return null;
  } else {
    start = 0;
    isNegative = false;
    limit = -2147483647;
  }
  var limitForMaxRadix = -59652323;
  var limitBeforeMul = limitForMaxRadix;
  var result = 0;
  var inductionVariable = start;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
      if (digit < 0)
        return null;
      if (result < limitBeforeMul) {
        if (limitBeforeMul === limitForMaxRadix) {
          limitBeforeMul = limit / radix | 0;
          if (result < limitBeforeMul) {
            return null;
          }
        } else {
          return null;
        }
      }
      result = imul_0(result, radix);
      if (result < (limit + digit | 0))
        return null;
      result = result - digit | 0;
    }
     while (inductionVariable < length);
  return isNegative ? result : -result | 0;
}
function _Duration___init__impl__kdtzql(rawValue) {
  // Inline function 'kotlin.time.durationAssertionsEnabled' call
  if (true) {
    if (isInNanos(rawValue)) {
      var containsArg = _get_value__a43j40_0(rawValue);
      if (!((new Long(387905, -1073741824)).m(containsArg) <= 0 ? containsArg.m(new Long(-387905, 1073741823)) <= 0 : false))
        throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + ' ns is out of nanoseconds range');
    } else {
      var containsArg_0 = _get_value__a43j40_0(rawValue);
      if (!((new Long(1, -1073741824)).m(containsArg_0) <= 0 ? containsArg_0.m(new Long(-1, 1073741823)) <= 0 : false))
        throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + ' ms is out of milliseconds range');
      var containsArg_1 = _get_value__a43j40_0(rawValue);
      if ((new Long(1108857478, -1074)).m(containsArg_1) <= 0 ? containsArg_1.m(new Long(-1108857478, 1073)) <= 0 : false)
        throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + ' ms is denormalized');
    }
  }
  return rawValue;
}
function _get_rawValue__5zfu4e($this) {
  return $this;
}
function _get_value__a43j40_0($this) {
  return _get_rawValue__5zfu4e($this).s1(1);
}
function isInNanos($this) {
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  return (_get_rawValue__5zfu4e($this).t1() & 1) === 0;
}
function isInMillis($this) {
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  return (_get_rawValue__5zfu4e($this).t1() & 1) === 1;
}
function _get_storageUnit__szjgha($this) {
  return isInNanos($this) ? DurationUnit_NANOSECONDS_getInstance() : DurationUnit_MILLISECONDS_getInstance();
}
function Companion_9() {
  Companion_instance_9 = this;
  this.f7_1 = _Duration___init__impl__kdtzql(new Long(0, 0));
  this.g7_1 = durationOfMillis(new Long(-1, 1073741823));
  this.h7_1 = durationOfMillis(new Long(1, -1073741824));
}
var Companion_instance_9;
function Companion_getInstance_9() {
  if (Companion_instance_9 == null)
    new Companion_9();
  return Companion_instance_9;
}
function Duration__isPositive_impl_tvkkt2($this) {
  return _get_rawValue__5zfu4e($this).m(new Long(0, 0)) > 0;
}
function Duration__isInfinite_impl_tsn9y3($this) {
  return _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_9().g7_1)) || _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_9().h7_1));
}
function _Duration___get_nanosecondsComponent__impl__nh19kq($this) {
  var tmp;
  if (Duration__isInfinite_impl_tsn9y3($this)) {
    tmp = 0;
  } else if (isInMillis($this)) {
    // Inline function 'kotlin.Long.rem' call
    var tmp$ret$0 = _get_value__a43j40_0($this).o1(toLong(1000));
    tmp = millisToNanos(tmp$ret$0).t1();
  } else {
    var tmp2 = _get_value__a43j40_0($this);
    // Inline function 'kotlin.Long.rem' call
    var other = 1000000000;
    tmp = tmp2.o1(toLong(other)).t1();
  }
  return tmp;
}
function Duration__toLong_impl_shr43i($this, unit) {
  var tmp0_subject = _get_rawValue__5zfu4e($this);
  return tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_9().g7_1)) ? new Long(-1, 2147483647) : tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_9().h7_1)) ? new Long(0, -2147483648) : convertDurationUnit(_get_value__a43j40_0($this), _get_storageUnit__szjgha($this), unit);
}
function _Duration___get_inWholeSeconds__impl__hpy7b3($this) {
  return Duration__toLong_impl_shr43i($this, DurationUnit_SECONDS_getInstance());
}
function durationOfMillis(normalMillis) {
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = normalMillis.r1(1).l1(toLong(1));
  return _Duration___init__impl__kdtzql(tmp$ret$0);
}
function toDuration(_this__u8e3s4, unit) {
  var tmp;
  if (unit.f1(DurationUnit_SECONDS_getInstance()) <= 0) {
    tmp = durationOfNanos(convertDurationUnitOverflow(toLong(_this__u8e3s4), unit, DurationUnit_NANOSECONDS_getInstance()));
  } else {
    tmp = toDuration_0(toLong(_this__u8e3s4), unit);
  }
  return tmp;
}
function toDuration_0(_this__u8e3s4, unit) {
  var maxNsInUnit = convertDurationUnitOverflow(new Long(-387905, 1073741823), DurationUnit_NANOSECONDS_getInstance(), unit);
  if (maxNsInUnit.p1().m(_this__u8e3s4) <= 0 ? _this__u8e3s4.m(maxNsInUnit) <= 0 : false) {
    return durationOfNanos(convertDurationUnitOverflow(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance()));
  } else {
    var millis = convertDurationUnit(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance());
    return durationOfMillis(coerceIn(millis, new Long(1, -1073741824), new Long(-1, 1073741823)));
  }
}
function millisToNanos(millis) {
  // Inline function 'kotlin.Long.times' call
  return millis.m1(toLong(1000000));
}
function durationOfNanos(normalNanos) {
  return _Duration___init__impl__kdtzql(normalNanos.r1(1));
}
function _UShort___init__impl__jigrne(data) {
  return data;
}
function _UShort___get_data__impl__g0245($this) {
  return $this;
}
//region block: post-declaration
protoOf(AbstractMap).asJsReadonlyMapView = asJsReadonlyMapView;
protoOf(AbstractMutableMap).asJsMapView = asJsMapView;
protoOf(InternalHashMap).c4 = containsAllEntries;
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Unit_instance = new Unit();
Companion_instance_4 = new Companion_4();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
EmptyIterator_instance = new EmptyIterator();
//endregion
//region block: exports
var KtMap = {getInstance: Companion_getInstance};
var KtMutableMap = {getInstance: Companion_getInstance_0};
export {
  KtMap as KtMap,
  KtMutableMap as KtMutableMap,
};
export {
  VOID as VOID7hggqo3abtya,
  RegexOption_IGNORE_CASE_getInstance as RegexOption_IGNORE_CASE_getInstance3gy6kkhlhefwp,
  DurationUnit_MILLISECONDS_getInstance as DurationUnit_MILLISECONDS_getInstance27okq1lv22wqm,
  ArrayList_init_$Create$ as ArrayList_init_$Create$2rimpp4x9tjd3,
  LinkedHashMap_init_$Create$_0 as LinkedHashMap_init_$Create$snys8oz8txtu,
  LinkedHashMap_init_$Create$ as LinkedHashMap_init_$Create$2gfxg59gogbfz,
  Regex_init_$Create$_0 as Regex_init_$Create$y1ec0tsv67vh,
  Regex_init_$Create$ as Regex_init_$Create$2bj3lgrxbttcb,
  IllegalArgumentException_init_$Create$_0 as IllegalArgumentException_init_$Create$sfel9vrfa7w2,
  _Duration___get_inWholeSeconds__impl__hpy7b3 as _Duration___get_inWholeSeconds__impl__hpy7b32mb043ng683qx,
  Duration__isPositive_impl_tvkkt2 as Duration__isPositive_impl_tvkkt23mvdjuzm9oa9z,
  _Duration___get_nanosecondsComponent__impl__nh19kq as _Duration___get_nanosecondsComponent__impl__nh19kq3qe435uvlnjyf,
  Companion_getInstance_9 as Companion_getInstance1mc3g3aij23my,
  Unit_instance as Unit_instance14hm69wy3kr8u,
  collectionSizeOrDefault as collectionSizeOrDefault36dulx8yinfqm,
  first as first58ocm7j58k3q,
  mapCapacity as mapCapacity1h45rc3eh9p2l,
  enumEntries as enumEntries20mr21zbe3az4,
  charSequenceLength as charSequenceLength3278n89t01tmv,
  defineProp as defineProp3hxgpk2knu2px,
  equals as equals2au1ep9vhcato,
  getBooleanHashCode as getBooleanHashCode1bbj3u6b3v0a7,
  getStringHashCode as getStringHashCode26igk1bx568vk,
  hashCode as hashCodeq5arwsb9dgti,
  initMetadataForClass as initMetadataForClassbxx6q50dy2s7,
  initMetadataForCompanion as initMetadataForCompanion1wyw17z38v6ac,
  initMetadataForInterface as initMetadataForInterface1egvbzx539z91,
  initMetadataForObject as initMetadataForObject1cxne3s9w65el,
  numberToInt as numberToInt1ygmcfwhs2fkq,
  protoOf as protoOf180f3jzyo7rfj,
  toString_1 as toString1pkumu07cwy4m,
  coerceAtLeast as coerceAtLeast2bkz8m9ik7hep,
  toIntOrNull as toIntOrNull3w2d066r9pvwm,
  toDuration as toDuration7gy6v749ektt,
  Enum as Enum3alwj03lh1n41,
  Long as Long2qws0ah9gnpki,
  THROW_CCE as THROW_CCE2g6jy02ryeudk,
  THROW_IAE as THROW_IAE23kobfj9wdoxr,
  noWhenBranchMatchedException as noWhenBranchMatchedException2a6r7ubxgky5j,
  toString_0 as toString30pk9tzaqopn,
};
//endregion

//# sourceMappingURL=kotlin-kotlin-stdlib.mjs.map
